/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * UserRole
 * An enumeration.
 */
export enum UserRole {
  Admin = "admin",
  User = "user",
}

/**
 * TaskResult
 * An enumeration.
 */
export enum TaskResult {
  Completed = "completed",
  Due = "due",
}

/**
 * TaskPriority
 * An enumeration.
 */
export enum TaskPriority {
  Normal = "normal",
  High = "high",
  Critical = "critical",
}

/**
 * TaskListMode
 * An enumeration.
 */
export enum TaskListMode {
  Todo = "todo",
  History = "history",
  Upcoming = "upcoming",
  Overdue = "overdue",
  AllTasks = "all_tasks",
  Deleted = "deleted",
}

/**
 * ReportType
 * An enumeration.
 */
export enum ReportType {
  TaskActivityReport = "task_activity_report",
  OverdueTasksReport = "overdue_tasks_report",
  TaskResultsReport = "task_results_report",
  IncidentReport = "incident_report",
  BatchReport = "batch_report",
}

/**
 * ReportStatus
 * An enumeration.
 */
export enum ReportStatus {
  Generating = "generating",
  Completed = "completed",
  Failed = "failed",
}

/**
 * ReportFormat
 * An enumeration.
 */
export enum ReportFormat {
  Xlsx = "xlsx",
  Pdf = "pdf",
}

/**
 * RegisterResult
 * An enumeration.
 */
export enum RegisterResult {
  Compliant = "compliant",
  NotCompliant = "not_compliant",
  InProgress = "in_progress",
  NonApplicable = "non_applicable",
}

/**
 * PermissionLevel
 * An enumeration.
 */
export enum PermissionLevel {
  Viewer = "viewer",
  Editor = "editor",
  Approver = "approver",
  Owner = "owner",
}

/**
 * PartyRole
 * An enumeration.
 */
export enum PartyRole {
  Vendor = "vendor",
  Customer = "customer",
  Insurer = "insurer",
  Broker = "broker",
  Lessor = "lessor",
  Lessee = "lessee",
  Guarantor = "guarantor",
  ServiceProvider = "service_provider",
}

/**
 * NoticeTrigger
 * An enumeration.
 */
export enum NoticeTrigger {
  PreExpiry = "pre_expiry",
  AnyTime = "any_time",
  Milestone = "milestone",
}

/**
 * MeetingRecurrenceWeekIndex
 * An enumeration.
 */
export enum MeetingRecurrenceWeekIndex {
  First = "first",
  Second = "second",
  Third = "third",
  Fourth = "fourth",
  Last = "last",
}

/**
 * MeetingRecurrenceRangeType
 * An enumeration.
 */
export enum MeetingRecurrenceRangeType {
  NoEnd = "no_end",
  EndDate = "end_date",
  Numbered = "numbered",
}

/**
 * MeetingRecurrencePatternType
 * An enumeration.
 */
export enum MeetingRecurrencePatternType {
  Daily = "daily",
  Weekly = "weekly",
  AbsoluteMonthly = "absolute_monthly",
  RelativeMonthly = "relative_monthly",
  AbsoluteYearly = "absolute_yearly",
  RelativeYearly = "relative_yearly",
}

/**
 * MeetingDayOfWeek
 * An enumeration.
 */
export enum MeetingDayOfWeek {
  Sunday = "sunday",
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
}

/**
 * MeetingBodyType
 * An enumeration.
 */
export enum MeetingBodyType {
  Text = "text",
  Html = "html",
}

/**
 * JurisdictionType
 * An enumeration.
 */
export enum JurisdictionType {
  State = "state",
  Federal = "federal",
  International = "international",
  SpecialEconomicZone = "special_economic_zone",
}

/**
 * IncidentTypePriority
 * An enumeration.
 */
export enum IncidentTypePriority {
  Normal = "normal",
  High = "high",
  Critical = "critical",
}

/**
 * IncidentResultStatus
 * An enumeration.
 */
export enum IncidentResultStatus {
  Open = "open",
  Resolved = "resolved",
}

/**
 * EntityType
 * An enumeration.
 */
export enum EntityType {
  ProprietaryLimited = "proprietary_limited",
  Llc = "llc",
  Corporation = "corporation",
  Partnership = "partnership",
  SoleTrader = "sole_trader",
  Government = "government",
  Trust = "trust",
  NonProfit = "non_profit",
}

/**
 * DocumentSortBy
 * Enum for document sorting options
 */
export enum DocumentSortBy {
  CreatedAtAsc = "created_at_asc",
  CreatedAtDesc = "created_at_desc",
  SizeAsc = "size_asc",
  SizeDesc = "size_desc",
  FormatAsc = "format_asc",
  FormatDesc = "format_desc",
}

/**
 * CustomChartType
 * An enumeration.
 */
export enum CustomChartType {
  Pie = "pie",
  HorizontalBar = "horizontal_bar",
}

/**
 * CurrencyCode
 * An enumeration.
 */
export enum CurrencyCode {
  Aud = "aud",
  Usd = "usd",
  Gbp = "gbp",
  Eur = "eur",
  Sgd = "sgd",
  Nzd = "nzd",
}

/**
 * CoverageType
 * An enumeration.
 */
export enum CoverageType {
  PropertyAllRisk = "property_all_risk",
  PublicLiability = "public_liability",
  WorkersCompensation = "workers_compensation",
  BusinessInterruption = "business_interruption",
  CyberLiability = "cyber_liability",
  ProfessionalIndemnity = "professional_indemnity",
  DirectorsAndOfficers = "directors_and_officers",
  MachineryBreakdown = "machinery_breakdown",
  GlassBreakage = "glass_breakage",
  TheftAndMoney = "theft_and_money",
  Other = "other",
}

/**
 * ContractValuePeriod
 * An enumeration.
 */
export enum ContractValuePeriod {
  Fixed = "fixed",
  Monthly = "monthly",
  Annual = "annual",
}

/**
 * ContractStatus
 * An enumeration.
 */
export enum ContractStatus {
  Draft = "draft",
  Active = "active",
  Expired = "expired",
  PendingRenewal = "pending_renewal",
  Archived = "archived",
  PendingReview = "pending_review",
}

/**
 * ContractFileKind
 * An enumeration.
 */
export enum ContractFileKind {
  PrimaryContract = "primary_contract",
  Attachment = "attachment",
}

/**
 * ContractCategory
 * An enumeration.
 */
export enum ContractCategory {
  SoftwareSaas = "software_saas",
  ProfessionalServices = "professional_services",
  MasterServicesAgreement = "master_services_agreement",
  NonDisclosureAgreement = "non_disclosure_agreement",
  InsurancePolicy = "insurance_policy",
  RealEstateLease = "real_estate_lease",
  EmploymentHr = "employment_hr",
  SupplyProcurement = "supply_procurement",
  PartnershipReferral = "partnership_referral",
  FinancialLoan = "financial_loan",
  MaintenanceSupport = "maintenance_support",
  MarketingMedia = "marketing_media",
  Other = "other",
}

/**
 * ComplianceStatus
 * An enumeration.
 */
export enum ComplianceStatus {
  Verified = "verified",
  PendingReview = "pending_review",
  Expired = "expired",
  InsufficientLimit = "insufficient_limit",
  Rejected = "rejected",
  NotRequired = "not_required",
}

/**
 * ComplianceRequirement
 * An enumeration.
 */
export enum ComplianceRequirement {
  PublicLiabilityInsurance = "public_liability_insurance",
  ProfessionalIndemnity = "professional_indemnity",
  WorkersCompensation = "workers_compensation",
  CyberInsurance = "cyber_insurance",
  TradeLicense = "trade_license",
  HealthSafetyPermit = "health_safety_permit",
  BackgroundCheck = "background_check",
  TaxComplianceCertificate = "tax_compliance_certificate",
  Other = "other",
}

/**
 * BusinessIDType
 * An enumeration.
 */
export enum BusinessIDType {
  Abn = "abn",
  Acn = "acn",
  Ein = "ein",
  Ssn = "ssn",
  Vat = "vat",
  Uen = "uen",
  Nzbn = "nzbn",
  Crn = "crn",
  Other = "other",
}

/**
 * ActivityType
 * An enumeration.
 */
export enum ActivityType {
  TaskCreated = "task_created",
  TaskUpdated = "task_updated",
  TaskDeleted = "task_deleted",
  TaskResultCreated = "task_result_created",
  TaskResultUpdated = "task_result_updated",
  TaskResultDeleted = "task_result_deleted",
  RegisterStatusChanged = "register_status_changed",
  DueReminderFinished = "due_reminder_finished",
  IncidentTypeCreated = "incident_type_created",
  IncidentTypeDeleted = "incident_type_deleted",
  IncidentTypeUpdated = "incident_type_updated",
  IncidentResultCreated = "incident_result_created",
  IncidentResultUpdated = "incident_result_updated",
  IncidentResultDeleted = "incident_result_deleted",
  IncidentTaskCompleted = "incident_task_completed",
  DocumentUploaded = "document_uploaded",
  DocumentUpdated = "document_updated",
  DocumentDeleted = "document_deleted",
  DocumentMoved = "document_moved",
  DocumentFolderCreated = "document_folder_created",
  DocumentFolderUpdated = "document_folder_updated",
  DocumentFolderDeleted = "document_folder_deleted",
  DocumentFolderMoved = "document_folder_moved",
  FormCreated = "form_created",
  FormUpdated = "form_updated",
  FormDeleted = "form_deleted",
  RegisterCreated = "register_created",
  RegisterUpdated = "register_updated",
  RegisterDeleted = "register_deleted",
  DepartmentCreated = "department_created",
  DepartmentUpdated = "department_updated",
  DepartmentDeleted = "department_deleted",
  ReportCreated = "report_created",
  ReportDeleted = "report_deleted",
  ClientCreated = "client_created",
  ClientUpdated = "client_updated",
  ClientDeleted = "client_deleted",
  EmailSent = "email_sent",
  UserAdded = "user_added",
  MeetingScheduled = "meeting_scheduled",
  MeetingUpdated = "meeting_updated",
  OrganisationUpdated = "organisation_updated",
  BatchReportCreated = "batch_report_created",
  ReportTemplateCreated = "report_template_created",
  VaultCreated = "vault_created",
  VaultUpdated = "vault_updated",
  VaultDeleted = "vault_deleted",
  VaultShared = "vault_shared",
  SecretCreated = "secret_created",
  SecretUpdated = "secret_updated",
  SecretDeleted = "secret_deleted",
  ContractCreated = "contract_created",
  ContractUpdated = "contract_updated",
  ContractDeleted = "contract_deleted",
  ContractContributorCreated = "contract_contributor_created",
  ContractContributorUpdated = "contract_contributor_updated",
  ContractContributorDeleted = "contract_contributor_deleted",
  ContractFileCreated = "contract_file_created",
  ContractFileUpdated = "contract_file_updated",
  ContractFileDeleted = "contract_file_deleted",
  ContractPartyCreated = "contract_party_created",
  ContractPartyUpdated = "contract_party_updated",
  ContractPartyDeleted = "contract_party_deleted",
  JurisdictionCreated = "jurisdiction_created",
  JurisdictionUpdated = "jurisdiction_updated",
  JurisdictionDeleted = "jurisdiction_deleted",
  PolicyCoverageCreated = "policy_coverage_created",
  PolicyCoverageUpdated = "policy_coverage_updated",
  PolicyCoverageDeleted = "policy_coverage_deleted",
  PartyCreated = "party_created",
  PartyUpdated = "party_updated",
  PartyDeleted = "party_deleted",
  PartyContactCreated = "party_contact_created",
  PartyContactUpdated = "party_contact_updated",
  PartyContactDeleted = "party_contact_deleted",
  PartyComplianceCreated = "party_compliance_created",
  PartyComplianceUpdated = "party_compliance_updated",
  PartyComplianceDeleted = "party_compliance_deleted",
}

/** AIKnowledgeResponse */
export interface AIKnowledgeResponse {
  /** Id */
  id: number;
  /** Text */
  text: string;
  /** Business Id */
  business_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ActivityLogResponse */
export interface ActivityLogResponse {
  /** Id */
  id: number;
  /** An enumeration. */
  type: ActivityType;
  /** Data */
  data: object;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created With Ai */
  created_with_ai: boolean;
}

/** AddUserRequest */
export interface AddUserRequest {
  /**
   * The first name of the user
   * @minLength 3
   * @maxLength 255
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 3
   * @maxLength 255
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
  /** The role of the user */
  role: UserRole;
  /** Redirect url */
  redirect_url?: string;
}

/** AddUserResponse */
export interface AddUserResponse {
  user: UserResponse;
}

/** AuthDetailsModel */
export interface AuthDetailsModel {
  /** Realmid */
  realmId?: string;
  /** Clientid */
  clientId?: string;
  /** Userid */
  userId?: string;
  /** Ipaddress */
  ipAddress?: string;
  /** Username */
  username?: string;
  /** Sessionid */
  sessionId?: string;
}

/** BackChannelLogoutRequest */
export interface BackChannelLogoutRequest {
  /** Time */
  time?: number;
  /** Realmid */
  realmId?: string;
  /** Uid */
  uid?: string;
  authDetails?: AuthDetailsModel;
  /** Details */
  details?: object;
  /** Type */
  type?: string;
}

/** BackChannelLogoutResponse */
export interface BackChannelLogoutResponse {
  /** Success */
  success: boolean;
}

/** BatchReportResponse */
export interface BatchReportResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Reports Quantity */
  reports_quantity: number;
  /** Business Id */
  business_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Templates
   * @default []
   */
  templates?: ReportTemplate[];
}

/** BulkCreatePublicLinksRequest */
export interface BulkCreatePublicLinksRequest {
  /** Task ID */
  task_id: number;
  /** Users IDs */
  users_ids: number[];
}

/** BulkCreatePublicLinksResponse */
export interface BulkCreatePublicLinksResponse {
  /** Public Link Responses */
  public_link_responses: PublicLinkResponse[];
}

/** BulkSendStartDateEmailsRequest */
export interface BulkSendStartDateEmailsRequest {
  /** Task Id */
  task_id: number;
  /** User Ids */
  user_ids: number[];
}

/** BulkSendStartDateEmailsResponse */
export interface BulkSendStartDateEmailsResponse {
  /** Success */
  success: boolean;
}

/** Business */
export interface Business {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Keycloak Organization Id */
  keycloak_organization_id?: string;
  /** Registration Address */
  registration_address?: string;
  /** Icon Storage Item Id */
  icon_storage_item_id?: string;
  /** Icon Url */
  icon_url?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
}

/** BusinessName */
export interface BusinessName {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** BusinessResponse */
export interface BusinessResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Registration Address */
  registration_address?: string;
  /** Icon Url */
  icon_url?: string;
  /** Icon Storage Item Id */
  icon_storage_item_id?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Keycloak Organization Id */
  keycloak_organization_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** ClientMinimal */
export interface ClientMinimal {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
}

/** ClientMinimalResponse */
export interface ClientMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ClientResponse */
export interface ClientResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Number Of Tasks
   * @default 0
   */
  number_of_tasks?: number;
  /**
   * Number Of Events
   * @default 0
   */
  number_of_events?: number;
  /**
   * Number Of Reports
   * @default 0
   */
  number_of_reports?: number;
  /**
   * Number Of Documents
   * @default 0
   */
  number_of_documents?: number;
}

/** ClientUpdate */
export interface ClientUpdate {
  /** Name */
  name?: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
}

/** ContractBusinessResponse */
export interface ContractBusinessResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ContractContributorCreateOnContractCreateData */
export interface ContractContributorCreateOnContractCreateData {
  /** User Id */
  user_id: number;
  /** @default "viewer" */
  permission_level?: PermissionLevel;
}

/** ContractContributorResponse */
export interface ContractContributorResponse {
  /** Id */
  id: number;
  /** Contract Id */
  contract_id: number;
  /** User Id */
  user_id: number;
  /** An enumeration. */
  permission_level: PermissionLevel;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ContractDepartmentResponse */
export interface ContractDepartmentResponse {
  /** Id */
  id: number;
  /** Business Id */
  business_id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ContractDetailContributorResponse */
export interface ContractDetailContributorResponse {
  /** Contributor Id */
  contributor_id: number;
  /** An enumeration. */
  permission_level: PermissionLevel;
  /** User Id */
  user_id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ContractDetailPartyResponse */
export interface ContractDetailPartyResponse {
  /** Contract Party Id */
  contract_party_id: number;
  /** An enumeration. */
  role_type: PartyRole;
  /** Party Id */
  party_id: number;
  /** Legal Name */
  legal_name: string;
  /** Business Identifier */
  business_identifier: string;
  /** An enumeration. */
  business_id_type: BusinessIDType;
  /** An enumeration. */
  entity_type: EntityType;
  /** Incorporation Country */
  incorporation_country: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ContractFileCreateOnContractCreateData */
export interface ContractFileCreateOnContractCreateData {
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name?: string;
  /**
   * File Data
   * @minLength 1
   */
  file_data?: string;
  /** @default "primary_contract" */
  file_kind?: ContractFileKind;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Uploaded By */
  uploaded_by?: number;
}

/** ContractFileResponse */
export interface ContractFileResponse {
  /** Id */
  id: number;
  /** Contract Id */
  contract_id: number;
  /** Storage Item Id */
  storage_item_id: string;
  /** An enumeration. */
  file_kind: ContractFileKind;
  /** Is Active */
  is_active: boolean;
  /** Uploaded By */
  uploaded_by?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ContractListItemResponse */
export interface ContractListItemResponse {
  /** Id */
  id: number;
  /** Contract Name */
  contract_name: string;
  /** An enumeration. */
  status: ContractStatus;
  /** An enumeration. */
  category?: ContractCategory;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** Total Value */
  total_value?: number;
  /** An enumeration. */
  currency_code: CurrencyCode;
  /** Parties */
  parties: ContractListPartyResponse[];
}

/** ContractListPartyResponse */
export interface ContractListPartyResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** ContractOwnerResponse */
export interface ContractOwnerResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** ContractPartyCreateOnContractCreateData */
export interface ContractPartyCreateOnContractCreateData {
  /** Party Id */
  party_id: number;
  /** An enumeration. */
  role_type: PartyRole;
}

/** ContractPartyResponse */
export interface ContractPartyResponse {
  /** Id */
  id: number;
  /** Contract Id */
  contract_id: number;
  /** Party Id */
  party_id: number;
  /** An enumeration. */
  role_type: PartyRole;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ContractResponse */
export interface ContractResponse {
  /** Id */
  id: number;
  /** Business Id */
  business_id: number;
  /** Name */
  name: string;
  /** An enumeration. */
  status: ContractStatus;
  /** An enumeration. */
  currency_code: CurrencyCode;
  /** Owner Id */
  owner_id?: number;
  /** Department Id */
  department_id: number;
  /** Jurisdiction Id */
  jurisdiction_id?: number;
  /** An enumeration. */
  category?: ContractCategory;
  /** Total Value */
  total_value?: number;
  /** An enumeration. */
  value_period?: ContractValuePeriod;
  /**
   * Effective Date
   * @format date
   */
  effective_date?: string;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** An enumeration. */
  notice_trigger?: NoticeTrigger;
  /** Notice Period Days */
  notice_period_days?: number;
  /** Term For Convenience */
  term_for_convenience?: boolean;
  /** Physical Storage Location */
  physical_storage_location?: string;
  /** Policy Number */
  policy_number?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** CreateAIKnowledgeItemRequest */
export interface CreateAIKnowledgeItemRequest {
  /**
   * Text
   * @minLength 1
   * @maxLength 1000
   */
  text: string;
}

/** CreateAIKnowledgeItemResponse */
export interface CreateAIKnowledgeItemResponse {
  ai_knowledge: AIKnowledgeResponse;
}

/** CreateBatchReportsRequest */
export interface CreateBatchReportsRequest {
  /** Name */
  name: string;
  /** Report Template Ids */
  report_template_ids: number[];
}

/** CreateBatchReportsResponse */
export interface CreateBatchReportsResponse {
  batch_report: BatchReportResponse;
}

/** CreateClientRequest */
export interface CreateClientRequest {
  /** Name */
  name: string;
  /**
   * Email
   * @default ""
   */
  email?: string;
  /**
   * Phone Number
   * @default ""
   */
  phone_number?: string;
}

/** CreateClientResponse */
export interface CreateClientResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Number Of Tasks
   * @default 0
   */
  number_of_tasks?: number;
  /**
   * Number Of Events
   * @default 0
   */
  number_of_events?: number;
  /**
   * Number Of Reports
   * @default 0
   */
  number_of_reports?: number;
  /**
   * Number Of Documents
   * @default 0
   */
  number_of_documents?: number;
}

/** CreateContractContributorRequest */
export interface CreateContractContributorRequest {
  /**
   * Contract Id
   * @exclusiveMin 0
   */
  contract_id: number;
  /**
   * User Id
   * @exclusiveMin 0
   */
  user_id: number;
  /** @default "viewer" */
  permission_level?: PermissionLevel;
}

/** CreateContractContributorResponse */
export interface CreateContractContributorResponse {
  contributor: ContractContributorResponse;
}

/** CreateContractFileRequest */
export interface CreateContractFileRequest {
  /** Contract Id */
  contract_id: number;
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * File Data
   * @minLength 1
   */
  file_data: string;
  /** @default "primary_contract" */
  file_kind?: ContractFileKind;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Uploaded By */
  uploaded_by?: number;
}

/** CreateContractFileResponse */
export interface CreateContractFileResponse {
  contract_file: ContractFileResponse;
}

/** CreateContractPartyRequest */
export interface CreateContractPartyRequest {
  /** Contract Id */
  contract_id: number;
  /** Party Id */
  party_id: number;
  /** An enumeration. */
  role_type: PartyRole;
}

/** CreateContractPartyResponse */
export interface CreateContractPartyResponse {
  contract_party: ContractPartyResponse;
}

/** CreateContractRequest */
export interface CreateContractRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @default "draft" */
  status?: ContractStatus;
  /** @default "aud" */
  currency_code?: CurrencyCode;
  /** Owner Id */
  owner_id?: number;
  /** Department Id */
  department_id: number;
  /** Jurisdiction Id */
  jurisdiction_id?: number;
  /** An enumeration. */
  category?: ContractCategory;
  /** Total Value */
  total_value?: number;
  /** An enumeration. */
  value_period?: ContractValuePeriod;
  /**
   * Effective Date
   * @format date
   */
  effective_date?: string;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** An enumeration. */
  notice_trigger?: NoticeTrigger;
  /** Notice Period Days */
  notice_period_days?: number;
  /** Term For Convenience */
  term_for_convenience?: boolean;
  /**
   * Physical Storage Location
   * @minLength 1
   * @maxLength 500
   */
  physical_storage_location?: string;
  /**
   * Policy Number
   * @minLength 1
   * @maxLength 100
   */
  policy_number?: string;
  jurisdiction?: JurisdictionCreateData;
  /** Policy Coverages */
  policy_coverages?: PolicyCoverageCreateOnContractCreateData[];
  /** Contributors */
  contributors?: ContractContributorCreateOnContractCreateData[];
  /** Parties */
  parties?: ContractPartyCreateOnContractCreateData[];
  /** Files */
  files?: ContractFileCreateOnContractCreateData[];
}

/** CreateContractResponse */
export interface CreateContractResponse {
  contract: ContractResponse;
  business?: ContractBusinessResponse;
  jurisdiction?: JurisdictionResponse;
  department?: ContractDepartmentResponse;
  owner?: ContractOwnerResponse;
  /** Parties */
  parties: ContractDetailPartyResponse[];
  /** Files */
  files: ContractFileResponse[];
  /** Policy Coverages */
  policy_coverages: PolicyCoverageResponse[];
  /** Contributors */
  contributors: ContractDetailContributorResponse[];
}

/** CreateCustomChartRequest */
export interface CreateCustomChartRequest {
  /**
   * The name of the custom chart
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Task ID */
  task_id?: number;
  /** Event type ID */
  event_type_id?: number;
  /**
   * Group by field
   * @maxLength 255
   */
  group_by: string;
  /**
   * Metric field
   * @maxLength 255
   */
  metric: string;
  /** Chart type */
  chart_type: string;
}

/** CreateCustomChartResponse */
export interface CreateCustomChartResponse {
  custom_chart: CustomChartResponse;
}

/** CreateDepartmentRequest */
export interface CreateDepartmentRequest {
  /**
   * The name of the department
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * User Ids
   * @default []
   */
  user_ids?: number[];
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
}

/** CreateDepartmentResponse */
export interface CreateDepartmentResponse {
  department: CreateDepartmentResponseSchema;
}

/** CreateDepartmentResponseSchema */
export interface CreateDepartmentResponseSchema {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** CreateDepartmentUserRequest */
export interface CreateDepartmentUserRequest {
  /** Department IDs */
  department_ids: number[];
  /** ids of users */
  user_ids: number[];
}

/** CreateDepartmentUserResponse */
export interface CreateDepartmentUserResponse {
  /** Success */
  success: boolean;
}

/** CreateDueRemainderRequest */
export interface CreateDueRemainderRequest {
  /**
   * Days Before Due
   * Days before due date to send reminder (1-90)
   */
  days_before_due?: number;
  /** Is When Overdue */
  is_when_overdue: boolean;
  /** Frequency */
  frequency: string;
  /**
   * Stop After
   * Days after due date to stop sending overdue reminders (1-90)
   */
  stop_after?: number;
}

/** CreateFolderRequest */
export interface CreateFolderRequest {
  /** Name */
  name: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /**
   * Color
   * @pattern ^#[0-9A-Fa-f]{6}$
   */
  color?: string;
  /** Client Id */
  client_id?: number;
}

/** CreateFolderResponse */
export interface CreateFolderResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /** Business Id */
  business_id: number;
  /** Created By User Id */
  created_by_user_id: number;
  /** Color */
  color?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Children Count
   * @default 0
   */
  children_count?: number;
  /**
   * Documents Count
   * @default 0
   */
  documents_count?: number;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id?: string;
}

/** CreateFormRequest */
export interface CreateFormRequest {
  /**
   * The name of the form
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** Form Data */
  data: object[];
  /**
   * Tag Ids
   * @default []
   */
  tag_ids?: number[];
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
}

/** CreateFormResponse */
export interface CreateFormResponse {
  form: FormResponse;
}

/** CreateIncidentResultRequest */
export interface CreateIncidentResultRequest {
  /**
   * The name of the incident
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** Incident ID */
  incident_id: number;
  /** Form Results */
  form_results: object;
  /**
   * Date occurred
   * @format date-time
   */
  date_occurred: string;
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
  /** Client Id */
  client_id?: number;
}

/** CreateIncidentResultResponse */
export interface CreateIncidentResultResponse {
  incident_result: IncidentResultResponse;
}

/** CreateIncidentTypeRequest */
export interface CreateIncidentTypeRequest {
  /**
   * The name of the incident
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** An enumeration. */
  priority: IncidentTypePriority;
  /** Responsible Department Id */
  responsible_department_id: number;
  /** id of the form */
  form_id: number;
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
  /** id of the completion form */
  completion_form_id?: number;
}

/** CreateIncidentTypeResponse */
export interface CreateIncidentTypeResponse {
  incident_type: IncidentTypeResponse;
}

/** CreateJurisdictionRequest */
export interface CreateJurisdictionRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Iso Country Code
   * @minLength 2
   * @maxLength 2
   */
  iso_country_code: string;
  /** An enumeration. */
  type?: JurisdictionType;
}

/** CreateJurisdictionResponse */
export interface CreateJurisdictionResponse {
  jurisdiction: JurisdictionResponse;
}

/** CreatePartyComplianceRequest */
export interface CreatePartyComplianceRequest {
  /** Party Id */
  party_id: number;
  /** An enumeration. */
  requirement_type: ComplianceRequirement;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** @default "pending_review" */
  status?: ComplianceStatus;
  /** Verified By */
  verified_by?: number;
  /**
   * Verified At
   * @format date-time
   */
  verified_at?: string;
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * File Data
   * @minLength 1
   */
  file_data: string;
}

/** CreatePartyComplianceResponse */
export interface CreatePartyComplianceResponse {
  party_compliance: PartyComplianceResponse;
}

/** CreatePartyContactRequest */
export interface CreatePartyContactRequest {
  /** Party Id */
  party_id: number;
  /**
   * Full Name
   * @minLength 1
   * @maxLength 255
   */
  full_name?: string;
  /**
   * Email
   * @minLength 1
   * @maxLength 255
   */
  email?: string;
  /**
   * Phone
   * @minLength 1
   * @maxLength 50
   */
  phone?: string;
  /** Is Authorised Signatory */
  is_authorised_signatory?: boolean;
}

/** CreatePartyContactResponse */
export interface CreatePartyContactResponse {
  party_contact: PartyContactResponse;
}

/** CreatePartyRequest */
export interface CreatePartyRequest {
  /**
   * Legal Name
   * @minLength 1
   * @maxLength 255
   */
  legal_name: string;
  /**
   * Trading Name
   * @minLength 1
   * @maxLength 255
   */
  trading_name?: string;
  /**
   * Business Identifier
   * @minLength 1
   * @maxLength 64
   */
  business_identifier: string;
  /** An enumeration. */
  business_id_type: BusinessIDType;
  /** An enumeration. */
  entity_type: EntityType;
  /**
   * Incorporation Country
   * @minLength 2
   * @maxLength 2
   */
  incorporation_country: string;
  /**
   * Phone
   * @minLength 1
   * @maxLength 50
   */
  phone?: string;
  /**
   * Address Line1
   * @minLength 1
   * @maxLength 255
   */
  address_line1?: string;
  /**
   * Address Line2
   * @minLength 1
   * @maxLength 255
   */
  address_line2?: string;
  /**
   * City
   * @minLength 1
   * @maxLength 120
   */
  city: string;
  /**
   * State
   * @minLength 1
   * @maxLength 120
   */
  state?: string;
  /**
   * Postcode
   * @minLength 1
   * @maxLength 20
   */
  postcode?: string;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Notes
   * @minLength 1
   * @maxLength 2000
   */
  notes?: string;
  /** Contacts */
  contacts?: PartyContactCreateOnPartyCreateData[];
  /** Party Compliance */
  party_compliance?: PartyComplianceCreateOnPartyCreateData[];
}

/** CreatePartyResponse */
export interface CreatePartyResponse {
  party: PartyResponse;
  /** Total Value */
  total_value: number;
  /** Contacts */
  contacts?: PartyContactResponse[];
  /** Party Compliance */
  party_compliance?: PartyComplianceResponse[];
  /** Contracts */
  contracts?: PartyLinkedContractResponse[];
}

/** CreatePolicyCoverageRequest */
export interface CreatePolicyCoverageRequest {
  /** Contract Id */
  contract_id: number;
  /** An enumeration. */
  coverage_type: CoverageType;
  /** Limit Amount */
  limit_amount?: number;
  /** Is Unlimited Coverage */
  is_unlimited_coverage?: boolean;
  /** Deductible Excess */
  deductible_excess?: number;
}

/** CreatePolicyCoverageResponse */
export interface CreatePolicyCoverageResponse {
  policy_coverage: PolicyCoverageResponse;
}

/** CreatePublicDocumentLinkResponse */
export interface CreatePublicDocumentLinkResponse {
  document: UserDocumentUpdateResponse;
}

/** CreatePublicFolderLinkResponse */
export interface CreatePublicFolderLinkResponse {
  folder: DocumentFolderResponse;
}

/** CreateQuickTaskRequest */
export interface CreateQuickTaskRequest {
  /**
   * The name of the task
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * The description of the task
   * @default ""
   */
  description?: string;
  /** @default "normal" */
  priority?: TaskPriority;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /**
   * User Ids
   * @default []
   */
  user_ids?: number[];
  /** id of the form */
  form_id: number;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** Client Id */
  client_id?: number;
}

/** CreateQuickTaskResponse */
export interface CreateQuickTaskResponse {
  task: TaskResponse;
}

/** CreateRegisterRequest */
export interface CreateRegisterRequest {
  /**
   * The name of the register
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
}

/** CreateRegisterResponse */
export interface CreateRegisterResponse {
  response: RegisterResponse;
}

/** CreateReportRequest */
export interface CreateReportRequest {
  /**
   * The name of the form
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /**
   * date range
   * List of exactly 2 dates representing start and end dates. If not provided, will use default range based on data availability.
   * @maxItems 2
   * @minItems 2
   */
  date_range?: string[];
  /** The type of report */
  type: ReportType;
  /** Register Ids */
  register_ids?: number[];
  /** Assignee Ids */
  assignee_ids?: number[];
  /** Department Ids */
  department_ids?: number[];
  /** Form Ids */
  form_ids?: number[];
  /** The format of report */
  format: ReportFormat;
  /** Incident Type Ids */
  incident_type_ids?: number[];
  /** Batch Report Id */
  batch_report_id?: number;
  /** An enumeration. */
  status?: TaskResult;
  /** Client Id */
  client_id?: number;
}

/** CreateReportResponse */
export interface CreateReportResponse {
  report: ReportResponse;
}

/** CreateReportTemplateRequest */
export interface CreateReportTemplateRequest {
  /** Name */
  name: string;
  /** An enumeration. */
  type: ReportType;
  /** An enumeration. */
  format: ReportFormat;
  /**
   * Assignee Ids
   * @default []
   */
  assignee_ids?: number[];
  /**
   * Date Range
   * @default []
   */
  date_range?: string[];
  /**
   * Task Ids
   * @default []
   */
  task_ids?: number[];
  /**
   * Form Ids
   * @default []
   */
  form_ids?: number[];
  /**
   * Register Ids
   * @default []
   */
  register_ids?: number[];
  /**
   * Incident Type Ids
   * @default []
   */
  incident_type_ids?: number[];
  /**
   * Department Ids
   * @default []
   */
  department_ids?: number[];
  /** Client Id */
  client_id?: number;
  /**
   * Is Favorite
   * @default false
   */
  is_favorite?: boolean;
  /** An enumeration. */
  status?: TaskResult;
}

/** CreateReportTemplateResponse */
export interface CreateReportTemplateResponse {
  report_template: ReportTemplateResponse;
}

/** CreateSecretRequest */
export interface CreateSecretRequest {
  /** Vault Id */
  vault_id: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Value
   * @minLength 1
   * @maxLength 50000
   */
  value: string;
}

/** CreateSecretResponse */
export interface CreateSecretResponse {
  secret: SecretResponse;
}

/** CreateTagRequest */
export interface CreateTagRequest {
  /**
   * The name of the tag
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/** CreateTagResponse */
export interface CreateTagResponse {
  tag: TagResponse;
}

/** CreateTaskDepartmentRequest */
export interface CreateTaskDepartmentRequest {
  /** Task ID */
  task_id: number;
  /** ids of the department */
  department_ids: number[];
}

/** CreateTaskDepartmentResponse */
export interface CreateTaskDepartmentResponse {
  /** Success */
  success: boolean;
}

/** CreateTaskRequest */
export interface CreateTaskRequest {
  /**
   * The name of the task
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** An enumeration. */
  priority: TaskPriority;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /**
   * User Ids
   * @default []
   */
  user_ids?: number[];
  /**
   * Users Overdue Subs
   * @default []
   */
  users_overdue_subs?: number[];
  /**
   * Departments Completed Subs
   * @default []
   */
  departments_completed_subs?: number[];
  /**
   * Departments Overdue Subs
   * @default []
   */
  departments_overdue_subs?: number[];
  /**
   * Users Completed Subs
   * @default []
   */
  users_completed_subs?: number[];
  /**
   * Department Ids
   * @default []
   */
  department_ids?: number[];
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete: boolean;
  /** id of the form */
  form_id: number;
  /**
   * description of the task
   * @default ""
   */
  description?: string;
  /**
   * Due Remainders
   * @default []
   */
  due_remainders?: CreateDueRemainderRequest[];
  /** Incident Result Id */
  incident_result_id?: number;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * Is Created With Ai
   * @default false
   */
  is_created_with_ai?: boolean;
  /** Client Id */
  client_id?: number;
}

/** CreateTaskResponse */
export interface CreateTaskResponse {
  task: TaskResponse;
}

/** CreateTaskResultRequest */
export interface CreateTaskResultRequest {
  /** Id of the task */
  task_id: number;
  /** Task Result Id */
  task_result_id?: number;
  /** Result of the task */
  result: TaskResult;
  /** Form result */
  form_results: object;
  /**
   * Registers
   * @default []
   */
  registers?: RegisterResultRequest[];
}

/** CreateTaskResultResponse */
export interface CreateTaskResultResponse {
  task_result: TaskResultResponse;
}

/** CreateTaskUserRequest */
export interface CreateTaskUserRequest {
  /** Task ID */
  task_id: number;
  /** ids of the users */
  user_ids: number[];
}

/** CreateTaskUserResponse */
export interface CreateTaskUserResponse {
  /** Success */
  success: boolean;
}

/** CreateVaultRequest */
export interface CreateVaultRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Description
   * @maxLength 5000
   */
  description?: string;
  /** Shared User Ids */
  shared_user_ids?: number[];
}

/** CreateVaultResponse */
export interface CreateVaultResponse {
  vault: VaultResponse;
}

/** CustomChartCalculationsGroupData */
export interface CustomChartCalculationsGroupData {
  /** Count */
  count: number;
  /** Group */
  group: string;
  /** Metric Average */
  metric_average: number;
  /** Metric Value */
  metric_value: number;
  /** Percentage */
  percentage: number;
}

/** CustomChartCalculationsResponse */
export interface CustomChartCalculationsResponse {
  /** Group By Field */
  group_by_field: string;
  /** Metric Field */
  metric_field: string;
  /** Total Records */
  total_records: number;
  /** Total Groups */
  total_groups: number;
  /** Total Metric Value */
  total_metric_value: number;
  /** Grouped Data */
  grouped_data: object;
  /** Data */
  data: CustomChartCalculationsGroupData[];
}

/** CustomChartResponse */
export interface CustomChartResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Task Id */
  task_id?: number;
  /** Event Type Id */
  event_type_id?: number;
  /** Business Id */
  business_id: number;
  /** Group By */
  group_by: string;
  /** Metric */
  metric: string;
  /** An enumeration. */
  chart_type: CustomChartType;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** DashboardGraphicItem */
export interface DashboardGraphicItem {
  /**
   * Calculated Date
   * @format date
   */
  calculated_date: string;
  /** Amount */
  amount: number;
}

/** DeleteAIKnowledgeItemResponse */
export interface DeleteAIKnowledgeItemResponse {
  /** Success */
  success: boolean;
}

/** DeleteBatchReportsResponse */
export interface DeleteBatchReportsResponse {
  /** Success */
  success: boolean;
}

/** DeleteClientResponse */
export interface DeleteClientResponse {
  /** Success */
  success: boolean;
}

/** DeleteContractContributorResponse */
export interface DeleteContractContributorResponse {
  /** Success */
  success: boolean;
}

/** DeleteContractFileResponse */
export interface DeleteContractFileResponse {
  /** Success */
  success: boolean;
}

/** DeleteContractPartyResponse */
export interface DeleteContractPartyResponse {
  /** Success */
  success: boolean;
}

/** DeleteContractResponse */
export interface DeleteContractResponse {
  /** Success */
  success: boolean;
}

/** DeleteCustomChartResponse */
export interface DeleteCustomChartResponse {
  /** Success */
  success: boolean;
}

/** DeleteDepartmentRequest */
export interface DeleteDepartmentRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** DeleteDepartmentResponse */
export interface DeleteDepartmentResponse {
  /** Success */
  success: boolean;
}

/** DeleteDepartmentUserRequest */
export interface DeleteDepartmentUserRequest {
  /** Task ID */
  department_id: number;
  /** ids of the users */
  user_ids: number[];
}

/** DeleteDepartmentUserResponse */
export interface DeleteDepartmentUserResponse {
  /** Success */
  success: boolean;
}

/** DeleteFolderResponse */
export interface DeleteFolderResponse {
  /** Message */
  message: string;
  /** Deleted Folder Id */
  deleted_folder_id: number;
}

/** DeleteFormResponse */
export interface DeleteFormResponse {
  /** Success */
  success: boolean;
}

/** DeleteIncidentResultResponse */
export interface DeleteIncidentResultResponse {
  /** Success */
  success: boolean;
}

/** DeleteIncidentTypeResponse */
export interface DeleteIncidentTypeResponse {
  /** Success */
  success: boolean;
}

/** DeleteJurisdictionResponse */
export interface DeleteJurisdictionResponse {
  /** Success */
  success: boolean;
}

/** DeletePartyComplianceResponse */
export interface DeletePartyComplianceResponse {
  /** Success */
  success: boolean;
}

/** DeletePartyContactResponse */
export interface DeletePartyContactResponse {
  /** Success */
  success: boolean;
}

/** DeletePartyResponse */
export interface DeletePartyResponse {
  /** Success */
  success: boolean;
}

/** DeletePolicyCoverageResponse */
export interface DeletePolicyCoverageResponse {
  /** Success */
  success: boolean;
}

/** DeletePublicDocumentLinkResponse */
export interface DeletePublicDocumentLinkResponse {
  document: UserDocumentUpdateResponse;
}

/** DeletePublicFolderLinkResponse */
export interface DeletePublicFolderLinkResponse {
  folder: DocumentFolderResponse;
}

/** DeleteRegisterResponse */
export interface DeleteRegisterResponse {
  /** Success */
  success: boolean;
}

/** DeleteReportFromBatchResponse */
export interface DeleteReportFromBatchResponse {
  /** Success */
  success: boolean;
}

/** DeleteReportResponse */
export interface DeleteReportResponse {
  /** Success */
  success: boolean;
}

/** DeleteReportTemplateResponse */
export interface DeleteReportTemplateResponse {
  /** Success */
  success: boolean;
}

/** DeleteSecretResponse */
export interface DeleteSecretResponse {
  /** Success */
  success: boolean;
}

/** DeleteTagResponse */
export interface DeleteTagResponse {
  /** Success */
  success: boolean;
}

/** DeleteTaskDepartmentRequest */
export interface DeleteTaskDepartmentRequest {
  /** Task ID */
  task_id: number;
  /** ids of the users */
  department_ids: number[];
}

/** DeleteTaskRequest */
export interface DeleteTaskRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** DeleteTaskResponse */
export interface DeleteTaskResponse {
  /** Success */
  success: boolean;
}

/** DeleteTaskResultResponse */
export interface DeleteTaskResultResponse {
  /** Whether the deletion was successful */
  success: boolean;
}

/** DeleteTaskUserRequest */
export interface DeleteTaskUserRequest {
  /** Task ID */
  task_id: number;
  /** ids of the users */
  user_ids: number[];
}

/** DeleteTaskUserResponse */
export interface DeleteTaskUserResponse {
  /** Success */
  success: boolean;
}

/** DeleteUserBusinessRequest */
export interface DeleteUserBusinessRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** DeleteUserBusinessResponse */
export interface DeleteUserBusinessResponse {
  /** Success */
  success: boolean;
}

/** DeleteUserDocumentResponse */
export interface DeleteUserDocumentResponse {
  /** Success */
  success: boolean;
}

/** DeleteUserPhotoResponse */
export interface DeleteUserPhotoResponse {
  /** Status */
  status: boolean;
}

/** DeleteUserRequest */
export interface DeleteUserRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** DeleteUserResponse */
export interface DeleteUserResponse {
  /** Success */
  success: boolean;
}

/** DeleteVaultResponse */
export interface DeleteVaultResponse {
  /** Success */
  success: boolean;
}

/** DepartmentLookupResponse */
export interface DepartmentLookupResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** DepartmentMinimalResponse */
export interface DepartmentMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** DepartmentResponse */
export interface DepartmentResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Business Id */
  business_id: number;
  /** Users Count */
  users_count?: number;
  /** Tasks Count */
  tasks_count?: number;
  /**
   * Users
   * @default []
   */
  users?: number[];
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Created With Ai */
  created_with_ai: boolean;
}

/** DocumentFolderResponse */
export interface DocumentFolderResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /** Business Id */
  business_id: number;
  /** Created By User Id */
  created_by_user_id: number;
  /** Color */
  color?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Children Count
   * @default 0
   */
  children_count?: number;
  /**
   * Documents Count
   * @default 0
   */
  documents_count?: number;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id?: string;
}

/** DocumentFolderTreeNode */
export interface DocumentFolderTreeNode {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /** Business Id */
  business_id: number;
  /** Created By User Id */
  created_by_user_id: number;
  /** Color */
  color?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Children
   * @default []
   */
  children?: DocumentFolderTreeNode[];
  /**
   * Children Count
   * @default 0
   */
  children_count?: number;
  /**
   * Documents Count
   * @default 0
   */
  documents_count?: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id?: string;
  /** Root Folder Name */
  root_folder_name?: string;
}

/** DocumentTreeNode */
export interface DocumentTreeNode {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Type */
  type: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /** Url */
  url?: string;
  /** Size */
  size?: number;
  /** Formatted Size */
  formatted_size?: string;
  /** Content Type */
  content_type?: string;
  /**
   * Last Modified
   * @format date-time
   */
  last_modified?: string;
  /** Description */
  description?: string;
}

/** DownloadMergedBatchReportsRequest */
export interface DownloadMergedBatchReportsRequest {
  /**
   * Id
   * Batch report ID
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Start Date
   * Start date
   * @format date
   */
  start_date: string;
  /**
   * End Date
   * End date
   * @format date
   */
  end_date: string;
  /**
   * Name
   * Report name
   */
  name: string;
  /** Task status */
  status?: TaskResult;
}

/** DownloadMergedBatchReportsResponse */
export interface DownloadMergedBatchReportsResponse {
  /** Filename */
  filename: string;
  /** Name */
  name: string;
}

/** DueRemainder */
export interface DueRemainder {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Task Id */
  task_id: number;
  /** Days Before Due */
  days_before_due?: number;
  /** Is When Overdue */
  is_when_overdue: boolean;
  /** Frequency */
  frequency: string;
  /** Stop After */
  stop_after?: number;
}

/** Form */
export interface Form {
  /** Business Id */
  business_id: number;
  /** Name */
  name: string;
  /** Data */
  data: object[];
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Reference Name */
  reference_name?: string;
}

/** FormField */
export interface FormField {
  /** Name */
  name: string;
  /** Type */
  type: string;
  /** Label */
  label: string;
  /**
   * Is Number
   * @default false
   */
  is_number?: boolean;
}

/** FormItemResponse */
export interface FormItemResponse {
  /** Id */
  id: string;
  /** Label */
  label?: string;
  /** Form Id */
  form_id: number;
}

/** FormMinimalResponse */
export interface FormMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** FormResponse */
export interface FormResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Data */
  data: object[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Form Tags
   * @default []
   */
  form_tags?: FormTag[];
  /** Reference Name */
  reference_name?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** FormTag */
export interface FormTag {
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
}

/** GenerateBatchReportsRequest */
export interface GenerateBatchReportsRequest {
  /** Batch Report Id */
  batch_report_id: number;
  /**
   * date range
   * List of exactly 2 dates representing start and end dates
   * @maxItems 2
   * @minItems 2
   */
  date_range: string[];
}

/** GenerateBatchReportsResponse */
export interface GenerateBatchReportsResponse {
  /** Success */
  success: boolean;
}

/** GetAIContextResponse */
export interface GetAIContextResponse {
  users?: GetMinimalUserListResponse;
  registers?: GetMinimalRegisterListResponse;
  departments?: GetMinimalDepartmentListResponse;
  tasks?: GetMinimalTaskListResponse;
  forms?: GetMinimalFormListResponse;
  incidents?: GetMinimalIncidentTypeListResponse;
  incident_results?: GetMinimalIncidentResultListResponse;
  documents?: GetMinimalAllUserDocumentsResponse;
  ai_knowledge?: GetAIKnowledgeItemListResponse;
  clients?: GetClientsListResponse;
}

/** GetAIKnowledgeItemListResponse */
export interface GetAIKnowledgeItemListResponse {
  /** Total */
  total: number;
  /** Data */
  data: AIKnowledgeResponse[];
}

/** GetActivityLogListResponse */
export interface GetActivityLogListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ActivityLogResponse[];
}

/** GetAllUserDocumentsResponse */
export interface GetAllUserDocumentsResponse {
  /** Data */
  data: UserDocumentResponse[];
}

/** GetBatchDetailsResponse */
export interface GetBatchDetailsResponse {
  batch_report: BatchReportResponse;
  /** Reports */
  reports: ReportResponse[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

/** GetBatchReportsListResponse */
export interface GetBatchReportsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: BatchReportResponse[];
}

/** GetBusinessResponse */
export interface GetBusinessResponse {
  business: BusinessResponse;
}

/** GetClientsListResponse */
export interface GetClientsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ClientResponse[];
}

/** GetContractContributorResponse */
export interface GetContractContributorResponse {
  contributor: ContractContributorResponse;
}

/** GetContractContributorsListResponse */
export interface GetContractContributorsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ContractContributorResponse[];
}

/** GetContractCreateLookupsResponse */
export interface GetContractCreateLookupsResponse {
  /** Jurisdictions */
  jurisdictions: JurisdictionLookupResponse[];
  /** Departments */
  departments: DepartmentLookupResponse[];
  /** Users */
  users: UserLookupResponse[];
  /** Parties */
  parties: PartyLookupResponse[];
}

/** GetContractFileResponse */
export interface GetContractFileResponse {
  contract_file: ContractFileResponse;
}

/** GetContractFilesListResponse */
export interface GetContractFilesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ContractFileResponse[];
}

/** GetContractPartiesListResponse */
export interface GetContractPartiesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ContractPartyResponse[];
}

/** GetContractPartyResponse */
export interface GetContractPartyResponse {
  contract_party: ContractPartyResponse;
}

/** GetContractResponse */
export interface GetContractResponse {
  contract: ContractResponse;
  business?: ContractBusinessResponse;
  jurisdiction?: JurisdictionResponse;
  department?: ContractDepartmentResponse;
  owner?: ContractOwnerResponse;
  /** Parties */
  parties: ContractDetailPartyResponse[];
  /** Files */
  files: ContractFileResponse[];
  /** Policy Coverages */
  policy_coverages: PolicyCoverageResponse[];
  /** Contributors */
  contributors: ContractDetailContributorResponse[];
}

/** GetContractsListResponse */
export interface GetContractsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ContractListItemResponse[];
}

/** GetCurrentUserResponse */
export interface GetCurrentUserResponse {
  user: UserResponse;
  /** Businesses */
  businesses: BusinessResponse[];
  /**
   * Departments
   * @default []
   */
  departments?: AppUsersDomainEntitiesDepartment[];
}

/** GetCustomChartListResponse */
export interface GetCustomChartListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: CustomChartResponse[];
}

/** GetCustomChartResponse */
export interface GetCustomChartResponse {
  custom_chart: CustomChartResponse;
}

/** GetDashboardGraphicDataResponse */
export interface GetDashboardGraphicDataResponse {
  /** Completed Data */
  completed_data: DashboardGraphicItem[];
  /** Due Data */
  due_data: DashboardGraphicItem[];
}

/** GetDepartmentListResponse */
export interface GetDepartmentListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: DepartmentResponse[];
}

/** GetDepartmentResponse */
export interface GetDepartmentResponse {
  department: DepartmentResponse;
}

/** GetDocumentFolderTreeResponse */
export interface GetDocumentFolderTreeResponse {
  /** Tree */
  tree: DocumentFolderTreeNode[];
}

/** GetDocumentTreeResponse */
export interface GetDocumentTreeResponse {
  /** Tree */
  tree: DocumentTreeNode[];
}

/** GetFormFieldsResponse */
export interface GetFormFieldsResponse {
  /** Fields */
  fields: FormField[];
}

/** GetFormListResponse */
export interface GetFormListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: FormResponse[];
}

/** GetFormResponse */
export interface GetFormResponse {
  forms: FormResponse;
}

/** GetFormsItemsListResponse */
export interface GetFormsItemsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: FormItemResponse[];
}

/** GetIncidentResultListResponse */
export interface GetIncidentResultListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IncidentResultWithIncidentTypeRelResponse[];
}

/** GetIncidentTypeListResponse */
export interface GetIncidentTypeListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IncidentTypeWithRelationsResponse[];
}

/** GetJurisdictionResponse */
export interface GetJurisdictionResponse {
  jurisdiction: JurisdictionResponse;
}

/** GetJurisdictionsListResponse */
export interface GetJurisdictionsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: JurisdictionResponse[];
}

/** GetMeetingDocumentsResponse */
export interface GetMeetingDocumentsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: MeetingDocumentItem[];
  /** Message */
  message?: string;
}

/** GetMeetingSummaryTemplatesResponse */
export interface GetMeetingSummaryTemplatesResponse {
  /** Data */
  data: MeetingSummaryTemplateItem[];
}

/** GetMinimalAllUserDocumentsResponse */
export interface GetMinimalAllUserDocumentsResponse {
  /** Data */
  data: UserDocumentMinimalResponse[];
}

/** GetMinimalDepartmentListResponse */
export interface GetMinimalDepartmentListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: DepartmentMinimalResponse[];
}

/** GetMinimalFormListResponse */
export interface GetMinimalFormListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: FormMinimalResponse[];
}

/** GetMinimalIncidentResultListResponse */
export interface GetMinimalIncidentResultListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IncidentResultMinimalResponse[];
}

/** GetMinimalIncidentTypeListResponse */
export interface GetMinimalIncidentTypeListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: IncidentTypeMinimalResponse[];
}

/** GetMinimalRegisterListResponse */
export interface GetMinimalRegisterListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterResponse[];
}

/** GetMinimalTaskListResponse */
export interface GetMinimalTaskListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: GetTasksListMinimalResponse[];
}

/** GetMinimalUserListResponse */
export interface GetMinimalUserListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: UserMinimalResponse[];
}

/** GetMonthStatisticsResponse */
export interface GetMonthStatisticsResponse {
  /** Upcoming Amount */
  upcoming_amount: number;
  /** Completed Amount */
  completed_amount: number;
  /** Completion Rate */
  completion_rate: number;
  /** Due Amount */
  due_amount: number;
}

/** GetPartiesListResponse */
export interface GetPartiesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PartyListItemResponse[];
}

/** GetPartyComplianceListResponse */
export interface GetPartyComplianceListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PartyComplianceResponse[];
}

/** GetPartyComplianceResponse */
export interface GetPartyComplianceResponse {
  party_compliance: PartyComplianceResponse;
}

/** GetPartyContactResponse */
export interface GetPartyContactResponse {
  party_contact: PartyContactResponse;
}

/** GetPartyContactsListResponse */
export interface GetPartyContactsListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PartyContactResponse[];
}

/** GetPartyResponse */
export interface GetPartyResponse {
  party: PartyResponse;
  /** Total Value */
  total_value: number;
  /** Contacts */
  contacts: PartyContactResponse[];
  /** Party Compliance */
  party_compliance: PartyComplianceResponse[];
  /** Contracts */
  contracts: PartyLinkedContractResponse[];
}

/** GetPolicyCoverageResponse */
export interface GetPolicyCoverageResponse {
  policy_coverage: PolicyCoverageResponse;
}

/** GetPolicyCoveragesListResponse */
export interface GetPolicyCoveragesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: PolicyCoverageResponse[];
}

/** GetPublicDocumentFolderTreeResponse */
export interface GetPublicDocumentFolderTreeResponse {
  /** Tree */
  tree: DocumentFolderTreeNode[];
}

/** GetPublicUserDocumentResponse */
export interface GetPublicUserDocumentResponse {
  document: UserDocumentResponse;
}

/** GetPublicUserDocumentsResponse */
export interface GetPublicUserDocumentsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: UserDocumentResponse[];
}

/** GetRegisterListPublicAccessResponse */
export interface GetRegisterListPublicAccessResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterExtendResponse[];
}

/** GetRegisterListResponse */
export interface GetRegisterListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: RegisterExtendResponse[];
}

/** GetRegisterResponse */
export interface GetRegisterResponse {
  response: RegisterResponse;
}

/** GetReportListResponse */
export interface GetReportListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ReportResponse[];
}

/** GetReportTemplateResponse */
export interface GetReportTemplateResponse {
  report_template: ReportTemplateResponse;
  /**
   * Forms
   * @default []
   */
  forms?: Form[];
  /**
   * Registers
   * @default []
   */
  registers?: Register[];
  /**
   * Incident Types
   * @default []
   */
  incident_types?: IncidentType[];
  /**
   * Assignees
   * @default []
   */
  assignees?: UserResponse[];
  /**
   * Departments
   * @default []
   */
  departments?: DepartmentResponse[];
}

/** GetReportTemplatesListResponse */
export interface GetReportTemplatesListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ReportTemplateResponse[];
}

/** GetScheduledMeetingResponse */
export interface GetScheduledMeetingResponse {
  data: ScheduledMeetingDetailItem;
}

/** GetScheduledMeetingsResponse */
export interface GetScheduledMeetingsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: ScheduledMeetingListItem[];
}

/** GetTagsListResponse */
export interface GetTagsListResponse {
  /** Tags */
  tags: TagResponse[];
}

/** GetTaskListResponse */
export interface GetTaskListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TaskListWithRelationsResponse[];
}

/** GetTaskPublicAccessResponse */
export interface GetTaskPublicAccessResponse {
  task: TaskWithRelationsPublicAccessResponse;
}

/** GetTaskResponse */
export interface GetTaskResponse {
  task: TaskWithRelationsResponse;
}

/** GetTasksByIncidentResponse */
export interface GetTasksByIncidentResponse {
  /** Tasks */
  tasks: TaskWithRelationsResponse[];
}

/** GetTasksListMinimalResponse */
export interface GetTasksListMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** GetTasksResultsItemsResponse */
export interface GetTasksResultsItemsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: TaskResultItemResponse[];
}

/** GetUpcomingTaskChartResponse */
export interface GetUpcomingTaskChartResponse {
  /** Dates */
  dates: Record<string, TaskChartItem[]>;
}

/** GetUserBusinessResponse */
export interface GetUserBusinessResponse {
  /** Data */
  data: UserBusinessResponse[];
}

/** GetUserDocumentsResponse */
export interface GetUserDocumentsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: UserDocumentResponse[];
}

/** GetUserListResponse */
export interface GetUserListResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: UserResponse[];
}

/** GetUsersByDepartmentResponse */
export interface GetUsersByDepartmentResponse {
  department: UsersByDepartmentResponse;
}

/** GetVaultResponse */
export interface GetVaultResponse {
  vault: VaultResponse;
}

/** GetVaultSecretsResponse */
export interface GetVaultSecretsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: SecretResponse[];
}

/** GetVaultsResponse */
export interface GetVaultsResponse {
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Data */
  data: VaultResponse[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IncidentResultMinimalResponse */
export interface IncidentResultMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** IncidentResultResponse */
export interface IncidentResultResponse {
  /** Id */
  id: number;
  /** Incident Id */
  incident_id: number;
  /** Name */
  name: string;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Resolved At
   * @format date-time
   */
  resolved_at?: string;
  /** An enumeration. */
  status: IncidentResultStatus;
  /** Form Results */
  form_results: object;
  /**
   * Date Occurred
   * @format date-time
   */
  date_occurred: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  client?: ClientMinimalResponse;
}

/** IncidentResultSchema */
export interface IncidentResultSchema {
  /** Name */
  name: string;
  /** Incident Id */
  incident_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Resolved At
   * @format date-time
   */
  resolved_at?: string;
  /** An enumeration. */
  status: IncidentResultStatus;
  /** Form Results */
  form_results: object;
  /** Form Resolved Results */
  form_resolved_results?: object;
  /**
   * Date Occurred
   * @format date-time
   */
  date_occurred: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /** Client Id */
  client_id?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  client?: ClientMinimal;
}

/** IncidentResultSchemaWithRel */
export interface IncidentResultSchemaWithRel {
  /** Name */
  name: string;
  /** Incident Id */
  incident_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Resolved At
   * @format date-time
   */
  resolved_at?: string;
  /** An enumeration. */
  status: IncidentResultStatus;
  /** Form Results */
  form_results: object;
  /** Form Resolved Results */
  form_resolved_results?: object;
  /**
   * Date Occurred
   * @format date-time
   */
  date_occurred: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /** Client Id */
  client_id?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  client?: ClientMinimal;
  user?: User;
  /** Incident Type Name */
  incident_type_name?: string;
  business?: BusinessName;
  /** Reference Name */
  reference_name?: string;
}

/** IncidentResultWithIncidentTypeRelResponse */
export interface IncidentResultWithIncidentTypeRelResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Incident Id */
  incident_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Resolved At
   * @format date-time
   */
  resolved_at?: string;
  /** An enumeration. */
  status: IncidentResultStatus;
  /** Form Results */
  form_results: object;
  /**
   * Date Occurred
   * @format date-time
   */
  date_occurred: string;
  /** Incident Type Name */
  incident_type_name?: string;
  client?: ClientMinimalResponse;
  user: User;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Reference Name */
  reference_name?: string;
  /** Created With Ai */
  created_with_ai: boolean;
  /** Form Resolved Results */
  form_resolved_results?: object;
}

/** IncidentType */
export interface IncidentType {
  /** Name */
  name: string;
  /** An enumeration. */
  priority: IncidentTypePriority;
  /** Business Id */
  business_id: number;
  /** Form Id */
  form_id: number;
  /** Completion Form Id */
  completion_form_id?: number;
  /** Responsible Department Id */
  responsible_department_id: number;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** IncidentTypeMinimalResponse */
export interface IncidentTypeMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** IncidentTypeResponse */
export interface IncidentTypeResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Responsible Department Id */
  responsible_department_id: number;
  /** Business Id */
  business_id: number;
  /** Form Id */
  form_id: number;
  /** Completion Form Id */
  completion_form_id?: number;
  /** An enumeration. */
  priority: IncidentTypePriority;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  department?: AppTasksDomainEntitiesDepartment;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** IncidentTypeWithRelationsResponse */
export interface IncidentTypeWithRelationsResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /** Form Id */
  form_id: number;
  /** Completion Form Id */
  completion_form_id?: number;
  completion_form?: Form;
  form: Form;
  /** An enumeration. */
  priority: IncidentTypePriority;
  /** Responsible Department Id */
  responsible_department_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  department?: AppTasksDomainEntitiesDepartment;
  /**
   * Results
   * @default []
   */
  results?: IncidentResultSchemaWithRel[];
  /** Total Result Quantity */
  total_result_quantity: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Created With Ai */
  created_with_ai: boolean;
}

/** ItemShortInfo */
export interface ItemShortInfo {
  /** Name */
  name: string;
  /** Id */
  id: number;
}

/** JurisdictionCreateData */
export interface JurisdictionCreateData {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Iso Country Code
   * @minLength 2
   * @maxLength 2
   */
  iso_country_code: string;
  /** An enumeration. */
  type?: JurisdictionType;
}

/** JurisdictionLookupResponse */
export interface JurisdictionLookupResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Iso Country Code */
  iso_country_code: string;
  /** An enumeration. */
  type?: JurisdictionType;
}

/** JurisdictionResponse */
export interface JurisdictionResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Iso Country Code */
  iso_country_code: string;
  /** An enumeration. */
  type?: JurisdictionType;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** MeetingDocumentItem */
export interface MeetingDocumentItem {
  /** Id */
  id: number;
  /**
   * Date
   * @format date-time
   */
  date?: string;
  summary_document?: UserDocumentResponse;
  transcript_document?: UserDocumentResponse;
}

/** MeetingSummaryTemplateItem */
export interface MeetingSummaryTemplateItem {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** MoveDocumentRequest */
export interface MoveDocumentRequest {
  /** Document Id */
  document_id: number;
  /** Folder Id */
  folder_id?: number;
}

/** MoveDocumentResponse */
export interface MoveDocumentResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Folder Id */
  folder_id?: number;
  /** Business Id */
  business_id: number;
  /** Uploaded By User Id */
  uploaded_by_user_id: number;
  /** File Storage Item Id */
  file_storage_item_id: string;
  /** Size */
  size?: number;
  /** Format */
  format?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /**
   * Public Document Id
   * @format uuid
   */
  public_document_id?: string;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
}

/** MoveFolderRequest */
export interface MoveFolderRequest {
  /** Folder Id */
  folder_id: number;
  /** New Parent Folder Id */
  new_parent_folder_id?: number;
}

/** MoveFolderResponse */
export interface MoveFolderResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Parent Folder Id */
  parent_folder_id?: number;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /** Business Id */
  business_id: number;
  /** Created By User Id */
  created_by_user_id: number;
  /** Color */
  color?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Children Count
   * @default 0
   */
  children_count?: number;
  /**
   * Documents Count
   * @default 0
   */
  documents_count?: number;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id?: string;
}

/** PartyComplianceCreateOnPartyCreateData */
export interface PartyComplianceCreateOnPartyCreateData {
  /** An enumeration. */
  requirement_type: ComplianceRequirement;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** @default "pending_review" */
  status?: ComplianceStatus;
  /** Verified By */
  verified_by?: number;
  /**
   * Verified At
   * @format date-time
   */
  verified_at?: string;
  /**
   * File Name
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * File Data
   * @minLength 1
   */
  file_data: string;
}

/** PartyComplianceResponse */
export interface PartyComplianceResponse {
  /** Id */
  id: number;
  /** Party Id */
  party_id: number;
  /** An enumeration. */
  requirement_type: ComplianceRequirement;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** An enumeration. */
  status: ComplianceStatus;
  /** Verified By */
  verified_by?: number;
  /**
   * Verified At
   * @format date-time
   */
  verified_at?: string;
  /** Storage Item Id */
  storage_item_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** PartyContactCreateOnPartyCreateData */
export interface PartyContactCreateOnPartyCreateData {
  /**
   * Full Name
   * @minLength 1
   * @maxLength 255
   */
  full_name?: string;
  /**
   * Email
   * @minLength 1
   * @maxLength 255
   */
  email?: string;
  /**
   * Phone
   * @minLength 1
   * @maxLength 50
   */
  phone?: string;
  /** Is Authorised Signatory */
  is_authorised_signatory?: boolean;
}

/** PartyContactResponse */
export interface PartyContactResponse {
  /** Id */
  id: number;
  /** Party Id */
  party_id: number;
  /** Full Name */
  full_name?: string;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Is Authorised Signatory */
  is_authorised_signatory?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
}

/** PartyLinkedContractResponse */
export interface PartyLinkedContractResponse {
  /** Contract Id */
  contract_id: number;
  /** Contract Name */
  contract_name: string;
  /** An enumeration. */
  contract_status: ContractStatus;
  /**
   * Contract Expiry Date
   * @format date
   */
  contract_expiry_date?: string;
  /** Contract Total Value */
  contract_total_value?: number;
  /** An enumeration. */
  role_type: PartyRole;
}

/** PartyListItemResponse */
export interface PartyListItemResponse {
  /** Id */
  id: number;
  /** Party Name */
  party_name: string;
  /** Registration Number */
  registration_number: string;
  /** Incorporation Country */
  incorporation_country: string;
  /** City */
  city: string;
  /** State */
  state?: string;
  /** Total Value */
  total_value: number;
  /** Linked Contracts */
  linked_contracts: number;
}

/** PartyLookupResponse */
export interface PartyLookupResponse {
  /** Id */
  id: number;
  /** Legal Name */
  legal_name: string;
  /** Business Identifier */
  business_identifier: string;
}

/** PartyResponse */
export interface PartyResponse {
  /** Id */
  id: number;
  /** Business Id */
  business_id: number;
  /** Legal Name */
  legal_name: string;
  /** Trading Name */
  trading_name?: string;
  /** Business Identifier */
  business_identifier: string;
  /** An enumeration. */
  business_id_type: BusinessIDType;
  /** An enumeration. */
  entity_type: EntityType;
  /** Incorporation Country */
  incorporation_country: string;
  /** Phone */
  phone?: string;
  /** Address Line1 */
  address_line1?: string;
  /** Address Line2 */
  address_line2?: string;
  /** City */
  city: string;
  /** State */
  state?: string;
  /** Postcode */
  postcode?: string;
  /** Is Active */
  is_active: boolean;
  /** Notes */
  notes?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** PolicyCoverageCreateOnContractCreateData */
export interface PolicyCoverageCreateOnContractCreateData {
  /** An enumeration. */
  coverage_type: CoverageType;
  /** Limit Amount */
  limit_amount?: number;
  /** Is Unlimited Coverage */
  is_unlimited_coverage?: boolean;
  /** Deductible Excess */
  deductible_excess?: number;
}

/** PolicyCoverageResponse */
export interface PolicyCoverageResponse {
  /** Id */
  id: number;
  /** Contract Id */
  contract_id: number;
  /** An enumeration. */
  coverage_type: CoverageType;
  /** Limit Amount */
  limit_amount?: number;
  /** Is Unlimited Coverage */
  is_unlimited_coverage?: boolean;
  /** Deductible Excess */
  deductible_excess?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** PublicAccessCreateTaskResultRequest */
export interface PublicAccessCreateTaskResultRequest {
  /** Task Result Id */
  task_result_id?: number;
  /** Result of the task */
  result: TaskResult;
  /** Form result */
  form_results: object;
  /**
   * Registers
   * @default []
   */
  registers?: RegisterResultRequest[];
  /**
   * Association of the task
   * @format uuid
   */
  association: string;
  /** Business ID for validation */
  business_id: number;
}

/** PublicAccessCreateTaskResultResponse */
export interface PublicAccessCreateTaskResultResponse {
  task_result: TaskResultResponse;
}

/** PublicLinkResponse */
export interface PublicLinkResponse {
  /** Link */
  link: string;
  /** Task Id */
  task_id: number;
  /** User Id */
  user_id: number;
}

/** RecallMeetingWebhookResponse */
export interface RecallMeetingWebhookResponse {
  /** Success */
  success: boolean;
}

/** Register */
export interface Register {
  /** Business Id */
  business_id: number;
  /** Name */
  name: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
}

/** RegisterExtendResponse */
export interface RegisterExtendResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** In Progress Task Results Quantity */
  in_progress_task_results_quantity?: number;
  /** Compliant Task Results Quantity */
  compliant_task_results_quantity?: number;
  /** Not Compliant Task Results Quantity */
  not_compliant_task_results_quantity?: number;
  /** Non Applicable Task Results Quantity */
  non_applicable_task_results_quantity?: number;
  /** Not Completed Task Results Quantity */
  not_completed_task_results_quantity?: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** RegisterResponse */
export interface RegisterResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** RegisterResultRequest */
export interface RegisterResultRequest {
  /** Register Id */
  register_id: number;
  /** An enumeration. */
  result: RegisterResult;
}

/** ReportResponse */
export interface ReportResponse {
  /** Id */
  id: number;
  /** An enumeration. */
  type: ReportType;
  /** Name */
  name: string;
  /** An enumeration. */
  format: ReportFormat;
  /** An enumeration. */
  status: ReportStatus;
  /**
   * Start Date
   * @format date-time
   */
  start_date?: string;
  /**
   * End Date
   * @format date-time
   */
  end_date?: string;
  /** Report File Storage Item Id */
  report_file_storage_item_id?: string;
  /** Url */
  url?: string;
  /** Business Id */
  business_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ReportTemplate */
export interface ReportTemplate {
  /** Name */
  name: string;
  /** An enumeration. */
  type: ReportType;
  /** An enumeration. */
  format: ReportFormat;
  /** Assignee Ids */
  assignee_ids: number[];
  /** Date Range */
  date_range: string[];
  /** Department Ids */
  department_ids: number[];
  /** Form Ids */
  form_ids: number[];
  /** Register Ids */
  register_ids: number[];
  /** Incident Type Ids */
  incident_type_ids: number[];
  /** Business Id */
  business_id: number;
  /** Client Id */
  client_id?: number;
  /**
   * Is Favorite
   * @default false
   */
  is_favorite?: boolean;
  /** An enumeration. */
  status?: TaskResult;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
}

/** ReportTemplateResponse */
export interface ReportTemplateResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** An enumeration. */
  type: ReportType;
  /** An enumeration. */
  format: ReportFormat;
  /** Assignee Ids */
  assignee_ids: number[];
  /** Date Range */
  date_range: string[];
  /** Department Ids */
  department_ids: number[];
  /** Form Ids */
  form_ids: number[];
  /** Register Ids */
  register_ids: number[];
  /** Incident Type Ids */
  incident_type_ids: number[];
  /** Business Id */
  business_id: number;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /**
   * Is Favorite
   * @default false
   */
  is_favorite?: boolean;
  /** An enumeration. */
  status?: TaskResult;
}

/** ResendEmailResponse */
export interface ResendEmailResponse {
  /** Success */
  success: boolean;
}

/** ResetUserTotpResponse */
export interface ResetUserTotpResponse {
  /** Success */
  success: boolean;
}

/** ResolveIncidentResultResponse */
export interface ResolveIncidentResultResponse {
  incident_result: IncidentResultResponse;
}

/** ResolveIncidentResultResultRequest */
export interface ResolveIncidentResultResultRequest {
  /** Incident Result ID */
  id: number;
  /** Incident Type ID */
  incident_id: number;
  /** Completion Form Results */
  completion_form_result?: object;
}

/** RestoreCustomChartRequest */
export interface RestoreCustomChartRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

/** RestoreCustomChartResponse */
export interface RestoreCustomChartResponse {
  custom_chart: CustomChartResponse;
}

/** RestoreFormRequest */
export interface RestoreFormRequest {
  /** Id */
  id: number;
}

/** RestoreFormResponse */
export interface RestoreFormResponse {
  form: FormResponse;
}

/** RestoreIncidentResultRequest */
export interface RestoreIncidentResultRequest {
  /** Id */
  id: number;
}

/** RestoreIncidentResultResponse */
export interface RestoreIncidentResultResponse {
  incident_result: IncidentResultResponse;
}

/** RestoreIncidentTypeRequest */
export interface RestoreIncidentTypeRequest {
  /** Id */
  id: number;
}

/** RestoreIncidentTypeResponse */
export interface RestoreIncidentTypeResponse {
  incident_type: IncidentTypeResponse;
}

/** RestoreTaskRequest */
export interface RestoreTaskRequest {
  /** Id */
  id: number;
}

/** RestoreTaskResponse */
export interface RestoreTaskResponse {
  task: TaskResponse;
}

/** RestoreTaskResultRequest */
export interface RestoreTaskResultRequest {
  /** Id */
  id: number;
}

/** RestoreTaskResultResponse */
export interface RestoreTaskResultResponse {
  task_result: TaskResultResponse;
}

/** ScheduleMeetingAttendee */
export interface ScheduleMeetingAttendee {
  /**
   * Email
   * @format email
   */
  email?: string;
  /** User Id */
  user_id?: number;
  /**
   * Name
   * @maxLength 255
   */
  name?: string;
}

/** ScheduleMeetingRecurrence */
export interface ScheduleMeetingRecurrence {
  /** An enumeration. */
  pattern_type: MeetingRecurrencePatternType;
  /**
   * Interval
   * @default 1
   */
  interval?: number;
  days_of_week?: MeetingDayOfWeek[];
  /** Day Of Month */
  day_of_month?: number;
  /** Month */
  month?: number;
  /** An enumeration. */
  first_day_of_week?: MeetingDayOfWeek;
  /** An enumeration. */
  index?: MeetingRecurrenceWeekIndex;
  /** @default "no_end" */
  range_type?: MeetingRecurrenceRangeType;
  /** Number Of Occurrences */
  number_of_occurrences?: number;
  /**
   * End Date
   * @format date
   */
  end_date?: string;
  /**
   * Start Date
   * @format date
   */
  start_date?: string;
}

/**
 * ScheduleMeetingRequest
 * Request to schedule a Microsoft Teams meeting.
 */
export interface ScheduleMeetingRequest {
  /**
   * Subject
   * @maxLength 255
   */
  subject: string;
  /**
   * Body
   * @maxLength 1000
   */
  body: string;
  /**
   * Start Time
   * @format date-time
   */
  start_time: string;
  /**
   * End Time
   * @format date-time
   */
  end_time: string;
  /** Attendees */
  attendees: ScheduleMeetingAttendee[];
  /**
   * Time Zone
   * @default "Australia/Sydney"
   */
  time_zone?: string;
  /** @default "html" */
  body_type?: MeetingBodyType;
  /**
   * Send Invitations
   * @default true
   */
  send_invitations?: boolean;
  /**
   * Is Online Meeting
   * @default true
   */
  is_online_meeting?: boolean;
  /**
   * Create Ai Bot
   * @default false
   */
  create_ai_bot?: boolean;
  /**
   * Bot Name
   * @maxLength 255
   */
  bot_name?: string;
  /** Template Id */
  template_id?: number;
  recurrence?: ScheduleMeetingRecurrence;
  /**
   * Location
   * @maxLength 255
   */
  location?: string;
}

/** ScheduleMeetingResponse */
export interface ScheduleMeetingResponse {
  /** Join Url */
  join_url?: string;
  /** Event Id */
  event_id?: string;
  /** Location */
  location?: string;
}

/** ScheduledMeetingAttendeeUser */
export interface ScheduledMeetingAttendeeUser {
  /** Id */
  id: number;
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Avatar Url */
  avatar_url?: string;
}

/** ScheduledMeetingDetailItem */
export interface ScheduledMeetingDetailItem {
  /** Id */
  id: number;
  /** Subject */
  subject: string;
  /** Body */
  body: string;
  /**
   * Start Time
   * @format date-time
   */
  start_time: string;
  /**
   * End Time
   * @format date-time
   */
  end_time: string;
  /** Time Zone */
  time_zone: string;
  /** An enumeration. */
  body_type: MeetingBodyType;
  /** Send Invitations */
  send_invitations?: boolean;
  /** Is Online Meeting */
  is_online_meeting: boolean;
  /** Attendee Users */
  attendee_users: ScheduledMeetingAttendeeUser[];
  /** External Attendee Emails */
  external_attendee_emails: string[];
  /** Recurrence */
  recurrence?: object;
  /** Join Url */
  join_url?: string;
  /** Event Id */
  event_id?: string;
  /** Create Ai Bot */
  create_ai_bot: boolean;
  /** Bot Name */
  bot_name: string;
  /** Template Id */
  template_id?: number;
  /** Organizer Email */
  organizer_email: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Location */
  location?: string;
}

/** ScheduledMeetingListItem */
export interface ScheduledMeetingListItem {
  /** Id */
  id: number;
  /** Subject */
  subject: string;
  /** Body */
  body: string;
  /**
   * Start Time
   * @format date-time
   */
  start_time: string;
  /**
   * End Time
   * @format date-time
   */
  end_time: string;
  /** Time Zone */
  time_zone: string;
  /** An enumeration. */
  body_type: MeetingBodyType;
  /** Send Invitations */
  send_invitations?: boolean;
  /** Is Online Meeting */
  is_online_meeting: boolean;
  /** Attendee Users */
  attendee_users: ScheduledMeetingAttendeeUser[];
  /** External Attendee Emails */
  external_attendee_emails: string[];
  /** Recurrence */
  recurrence?: object;
  /** Join Url */
  join_url?: string;
  /** Event Id */
  event_id?: string;
  /** Create Ai Bot */
  create_ai_bot: boolean;
  /** Bot Name */
  bot_name: string;
  /** Template Id */
  template_id?: number;
  /** Organizer Email */
  organizer_email: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Location */
  location?: string;
}

/** SearchUserDocumentsByContentResponse */
export interface SearchUserDocumentsByContentResponse {
  /** Data */
  data: UserDocumentResponse[];
}

/** SecretResponse */
export interface SecretResponse {
  /** Id */
  id: number;
  /** Vault Id */
  vault_id: number;
  /** Name */
  name: string;
  /** Value */
  value: string;
  /** Created By User Id */
  created_by_user_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** ShareVaultRequest */
export interface ShareVaultRequest {
  /** Vault Id */
  vault_id: number;
  /** Shared User Ids */
  shared_user_ids?: number[];
}

/** ShareVaultResponse */
export interface ShareVaultResponse {
  vault: VaultResponse;
}

/** SharedVaultUserResponse */
export interface SharedVaultUserResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Avatar Url */
  avatar_url?: string;
}

/** SignUpUserRequest */
export interface SignUpUserRequest {
  /**
   * The first name of the user
   * @minLength 1
   * @maxLength 100
   */
  first_name: string;
  /**
   * The last name of the user
   * @minLength 1
   * @maxLength 100
   */
  last_name: string;
  /**
   * The email of the user
   * @format email
   */
  email: string;
  /**
   * The password of the user
   * @format password
   * @minLength 1
   * @maxLength 300
   */
  password: string;
  /** The role of the user */
  role: UserRole;
  /** The business id of the business */
  business_id: number;
  /** Redirect url */
  redirect_url?: string;
}

/** SignUpUserResponse */
export interface SignUpUserResponse {
  user: UserResponse;
  /** Session */
  session: string;
}

/** TagResponse */
export interface TagResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** TaskChartItem */
export interface TaskChartItem {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** An enumeration. */
  priority: TaskPriority;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * Overdue Date
   * @format date-time
   */
  overdue_date?: string;
}

/** TaskListWithRelationsResponse */
export interface TaskListWithRelationsResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /** Author Id */
  author_id: number;
  /** Description */
  description: string;
  /**
   * Overdue Date
   * @format date-time
   */
  overdue_date: string;
  /** Form Id */
  form_id: number;
  /** An enumeration. */
  priority: TaskPriority;
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete: boolean;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Users
   * @default []
   */
  users?: User[];
  /** Form Name */
  form_name: string;
  /**
   * Task Results
   * @default []
   */
  task_results?: TaskResultResponse[];
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * Current Start Date
   * @format date-time
   */
  current_start_date: string;
  /**
   * Registers
   * @default []
   */
  registers?: Register[];
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Created With Ai */
  created_with_ai: boolean;
}

/** TaskResponse */
export interface TaskResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /** Author Id */
  author_id: number;
  /** Description */
  description: string;
  /** Form Id */
  form_id: number;
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete: boolean;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /** An enumeration. */
  priority: TaskPriority;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Incident Result Id */
  incident_result_id?: number;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
}

/** TaskResultItemResponse */
export interface TaskResultItemResponse {
  /** Id */
  id: string;
  user: User;
  /** Results */
  results: string[];
  /** Label */
  label?: string;
  /** Selected */
  selected: string[];
  form: ItemShortInfo;
  task: ItemShortInfo;
  /** Task Result Id */
  task_result_id: number;
  /** Date */
  date: string;
  /** Register Id */
  register_id: number;
}

/** TaskResultResponse */
export interface TaskResultResponse {
  /** Id */
  id: number;
  /** Task Id */
  task_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Completion Date
   * @format date-time
   */
  completion_date: string;
  /** An enumeration. */
  result: TaskResult;
  /** Form Results */
  form_results: object;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Reference Name */
  reference_name?: string;
  /** Task Name */
  task_name?: string;
}

/** TaskResultSchema */
export interface TaskResultSchema {
  /** Task Id */
  task_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Completion Date
   * @format date-time
   */
  completion_date: string;
  /** An enumeration. */
  result: TaskResult;
  /** Form Results */
  form_results: object;
  /**
   * Start Date
   * @format date-time
   */
  start_date?: string;
  /**
   * End Date
   * @format date-time
   */
  end_date?: string;
  /** An enumeration. */
  original_result?: TaskResult;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Reference Name */
  reference_name?: string;
  /** Task Name */
  task_name?: string;
}

/** TaskResultSchemaWithAssociation */
export interface TaskResultSchemaWithAssociation {
  /** Task Id */
  task_id: number;
  /** Completed By User Id */
  completed_by_user_id: number;
  /**
   * Completion Date
   * @format date-time
   */
  completion_date: string;
  /** An enumeration. */
  result: TaskResult;
  /** Form Results */
  form_results: object;
  /**
   * Start Date
   * @format date-time
   */
  start_date?: string;
  /**
   * End Date
   * @format date-time
   */
  end_date?: string;
  /** An enumeration. */
  original_result?: TaskResult;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Reference Name */
  reference_name?: string;
  /** Task Name */
  task_name?: string;
  /**
   * Association
   * @format uuid
   */
  association: string;
}

/** TaskWithRelationsPublicAccessResponse */
export interface TaskWithRelationsPublicAccessResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /** Author Id */
  author_id: number;
  /** Description */
  description: string;
  /** Form Id */
  form_id: number;
  form: Form;
  /** Incident Result Id */
  incident_result_id?: number;
  /** An enumeration. */
  priority: TaskPriority;
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete: boolean;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /**
   * Overdue Date
   * @format date-time
   */
  overdue_date?: string;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Users
   * @default []
   */
  users?: User[];
  /**
   * Departments
   * @default []
   */
  departments?: AppTasksDomainEntitiesDepartment[];
  /**
   * Task Results
   * @default []
   */
  task_results?: TaskResultSchemaWithAssociation[];
  /**
   * Due Remainders
   * @default []
   */
  due_remainders?: DueRemainder[];
  /**
   * Overdue Subs
   * @default []
   */
  overdue_subs?: User[];
  /**
   * Complete Subs
   * @default []
   */
  complete_subs?: User[];
  incident_result?: IncidentResultSchema;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** Created With Ai */
  created_with_ai?: boolean;
}

/** TaskWithRelationsResponse */
export interface TaskWithRelationsResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /** Author Id */
  author_id: number;
  /** Description */
  description: string;
  /** Form Id */
  form_id: number;
  form: Form;
  /** Incident Result Id */
  incident_result_id?: number;
  /** An enumeration. */
  priority: TaskPriority;
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete: boolean;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /**
   * Overdue Date
   * @format date-time
   */
  overdue_date?: string;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Users
   * @default []
   */
  users?: User[];
  /**
   * Departments
   * @default []
   */
  departments?: AppTasksDomainEntitiesDepartment[];
  /**
   * Task Results
   * @default []
   */
  task_results?: TaskResultSchema[];
  /**
   * Due Remainders
   * @default []
   */
  due_remainders?: DueRemainder[];
  /**
   * Overdue Subs
   * @default []
   */
  overdue_subs?: User[];
  /**
   * Complete Subs
   * @default []
   */
  complete_subs?: User[];
  incident_result?: IncidentResultSchema;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * Registers
   * @default []
   */
  registers?: Register[];
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /** Created With Ai */
  created_with_ai?: boolean;
  client?: ClientMinimalResponse;
}

/** UpdateAIKnowledgeItemRequest */
export interface UpdateAIKnowledgeItemRequest {
  /** Id */
  id: number;
  /** Text */
  text: string;
}

/** UpdateAIKnowledgeItemResponse */
export interface UpdateAIKnowledgeItemResponse {
  ai_knowledge: AIKnowledgeResponse;
}

/** UpdateBatchReportRequest */
export interface UpdateBatchReportRequest {
  /** Id */
  id: number;
  /** Name */
  name?: string;
  /**
   * Report Template Ids
   * @default []
   */
  report_template_ids?: number[];
}

/** UpdateBatchReportResponse */
export interface UpdateBatchReportResponse {
  batch_report: BatchReportResponse;
}

/** UpdateBusinessRequest */
export interface UpdateBusinessRequest {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
  /**
   * Name
   * @minLength 3
   * @maxLength 255
   */
  name: string;
  /** Registration Address */
  registration_address?: string;
  /** Icon Base64 */
  icon_base64?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
}

/** UpdateBusinessRequestBody */
export interface UpdateBusinessRequestBody {
  /**
   * Name
   * @minLength 3
   * @maxLength 255
   */
  name: string;
  /**
   * Registration Address
   * @maxLength 512
   */
  registration_address?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Icon Base64 */
  icon_base64?: string;
}

/** UpdateBusinessResponse */
export interface UpdateBusinessResponse {
  business: Business;
}

/** UpdateClientRequest */
export interface UpdateClientRequest {
  /** Client Id */
  client_id: number;
  data: ClientUpdate;
}

/** UpdateClientResponse */
export interface UpdateClientResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email?: string;
  /** Phone Number */
  phone_number?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Number Of Tasks
   * @default 0
   */
  number_of_tasks?: number;
  /**
   * Number Of Events
   * @default 0
   */
  number_of_events?: number;
  /**
   * Number Of Reports
   * @default 0
   */
  number_of_reports?: number;
  /**
   * Number Of Documents
   * @default 0
   */
  number_of_documents?: number;
}

/** UpdateContractContributorRequest */
export interface UpdateContractContributorRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /** An enumeration. */
  permission_level?: PermissionLevel;
}

/** UpdateContractContributorResponse */
export interface UpdateContractContributorResponse {
  contributor: ContractContributorResponse;
}

/** UpdateContractFileRequest */
export interface UpdateContractFileRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /** An enumeration. */
  file_kind?: ContractFileKind;
  /** Is Active */
  is_active?: boolean;
  /** Uploaded By */
  uploaded_by?: number;
}

/** UpdateContractFileResponse */
export interface UpdateContractFileResponse {
  contract_file: ContractFileResponse;
}

/** UpdateContractPartyRequest */
export interface UpdateContractPartyRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /** An enumeration. */
  role_type?: PartyRole;
}

/** UpdateContractPartyResponse */
export interface UpdateContractPartyResponse {
  contract_party: ContractPartyResponse;
}

/** UpdateContractRequest */
export interface UpdateContractRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /** An enumeration. */
  status?: ContractStatus;
  /** An enumeration. */
  currency_code?: CurrencyCode;
  /** Owner Id */
  owner_id?: number;
  /** Department Id */
  department_id?: number;
  /** Jurisdiction Id */
  jurisdiction_id?: number;
  /** An enumeration. */
  category?: ContractCategory;
  /** Total Value */
  total_value?: number;
  /** An enumeration. */
  value_period?: ContractValuePeriod;
  /**
   * Effective Date
   * @format date
   */
  effective_date?: string;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** An enumeration. */
  notice_trigger?: NoticeTrigger;
  /** Notice Period Days */
  notice_period_days?: number;
  /** Term For Convenience */
  term_for_convenience?: boolean;
  /**
   * Physical Storage Location
   * @minLength 1
   * @maxLength 500
   */
  physical_storage_location?: string;
  /**
   * Policy Number
   * @minLength 1
   * @maxLength 100
   */
  policy_number?: string;
}

/** UpdateContractResponse */
export interface UpdateContractResponse {
  contract: ContractResponse;
}

/** UpdateCurrentUserRequest */
export interface UpdateCurrentUserRequest {
  /** Document data in base64 string */
  avatar?: string;
}

/** UpdateCurrentUserResponse */
export interface UpdateCurrentUserResponse {
  user: UserResponse;
}

/** UpdateCustomChartRequest */
export interface UpdateCustomChartRequest {
  /**
   * Name of the custom chart
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * Group by field
   * @maxLength 255
   */
  group_by?: string;
  /**
   * Metric field
   * @maxLength 255
   */
  metric?: string;
  /** Chart type */
  chart_type?: string;
  /** ID of the custom chart */
  id: number;
}

/** UpdateCustomChartResponse */
export interface UpdateCustomChartResponse {
  custom_chart: CustomChartResponse;
}

/** UpdateDepartmentRequest */
export interface UpdateDepartmentRequest {
  /** Name of the business */
  name: string;
  /** ID of the business */
  id: number;
}

/** UpdateDepartmentResponse */
export interface UpdateDepartmentResponse {
  department: DepartmentResponse;
}

/** UpdateFolderRequest */
export interface UpdateFolderRequest {
  /** Folder Id */
  folder_id: number;
  /** Name */
  name: string;
  /**
   * Color
   * @pattern ^#[0-9A-Fa-f]{6}$
   */
  color?: string;
  /** Client Id */
  client_id?: number;
}

/** UpdateFormRequest */
export interface UpdateFormRequest {
  /**
   * Name of the form
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** Data to be updated */
  data?: object[];
  /** ID of the form */
  id: number;
  /**
   * Tag IDs to be updated
   * @default []
   */
  tag_ids?: number[];
}

/** UpdateFormResponse */
export interface UpdateFormResponse {
  form: FormResponse;
}

/** UpdateIncidentResultPartiallyRequest */
export interface UpdateIncidentResultPartiallyRequest {
  /** Unique Incident result ID */
  id: number;
  /**
   * The name of the incident
   * @minLength 1
   * @maxLength 50
   */
  name?: string;
  /** Form Results */
  form_results_updates?: object;
  /**
   * Date occurred
   * @format date-time
   */
  date_occurred?: string;
  /** Client Id */
  client_id?: number;
}

/** UpdateIncidentResultPartiallyResponse */
export interface UpdateIncidentResultPartiallyResponse {
  incident_result: IncidentResultResponse;
}

/** UpdateIncidentResultRequest */
export interface UpdateIncidentResultRequest {
  /** Unique Incident result ID */
  id: number;
  /**
   * The name of the incident
   * @minLength 1
   * @maxLength 50
   */
  name?: string;
  /** Form Results */
  form_results?: object;
  /** Form Resolved Results */
  form_resolved_results?: object;
  /**
   * Date occurred
   * @format date-time
   */
  date_occurred?: string;
  /** Client Id */
  client_id?: number;
}

/** UpdateIncidentResultResponse */
export interface UpdateIncidentResultResponse {
  incident_result: IncidentResultResponse;
}

/** UpdateIncidentTypePartiallyRequest */
export interface UpdateIncidentTypePartiallyRequest {
  /** Id */
  id: number;
  /** An enumeration. */
  priority?: IncidentTypePriority;
  /** Responsible Department Id */
  responsible_department_id?: number;
  /** Name */
  name?: string;
  /** Form Id */
  form_id?: number;
}

/** UpdateIncidentTypePartiallyResponse */
export interface UpdateIncidentTypePartiallyResponse {
  incident_type: IncidentTypeResponse;
}

/** UpdateIncidentTypeRequest */
export interface UpdateIncidentTypeRequest {
  /** Id */
  id: number;
  /** An enumeration. */
  priority?: IncidentTypePriority;
  /** Responsible Department Id */
  responsible_department_id?: number;
  /** Name */
  name?: string;
  /** Form Id */
  form_id?: number;
  /** Completion Form Id */
  completion_form_id?: number;
}

/** UpdateIncidentTypeResponse */
export interface UpdateIncidentTypeResponse {
  incident_type: IncidentTypeResponse;
}

/** UpdateJurisdictionRequest */
export interface UpdateJurisdictionRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * Iso Country Code
   * @minLength 2
   * @maxLength 2
   */
  iso_country_code?: string;
  /** An enumeration. */
  type?: JurisdictionType;
}

/** UpdateJurisdictionResponse */
export interface UpdateJurisdictionResponse {
  jurisdiction: JurisdictionResponse;
}

/** UpdatePartyComplianceRequest */
export interface UpdatePartyComplianceRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /** An enumeration. */
  requirement_type?: ComplianceRequirement;
  /**
   * Expiry Date
   * @format date
   */
  expiry_date?: string;
  /** An enumeration. */
  status?: ComplianceStatus;
  /** Verified By */
  verified_by?: number;
  /**
   * Verified At
   * @format date-time
   */
  verified_at?: string;
}

/** UpdatePartyComplianceResponse */
export interface UpdatePartyComplianceResponse {
  party_compliance: PartyComplianceResponse;
}

/** UpdatePartyContactRequest */
export interface UpdatePartyContactRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /**
   * Full Name
   * @minLength 1
   * @maxLength 255
   */
  full_name?: string;
  /**
   * Email
   * @minLength 1
   * @maxLength 255
   */
  email?: string;
  /**
   * Phone
   * @minLength 1
   * @maxLength 50
   */
  phone?: string;
  /** Is Authorised Signatory */
  is_authorised_signatory?: boolean;
}

/** UpdatePartyContactResponse */
export interface UpdatePartyContactResponse {
  party_contact: PartyContactResponse;
}

/** UpdatePartyRequest */
export interface UpdatePartyRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /**
   * Legal Name
   * @minLength 1
   * @maxLength 255
   */
  legal_name?: string;
  /**
   * Trading Name
   * @minLength 1
   * @maxLength 255
   */
  trading_name?: string;
  /**
   * Business Identifier
   * @minLength 1
   * @maxLength 64
   */
  business_identifier?: string;
  /** An enumeration. */
  business_id_type?: BusinessIDType;
  /** An enumeration. */
  entity_type?: EntityType;
  /**
   * Incorporation Country
   * @minLength 2
   * @maxLength 2
   */
  incorporation_country?: string;
  /**
   * Phone
   * @minLength 1
   * @maxLength 50
   */
  phone?: string;
  /**
   * Address Line1
   * @minLength 1
   * @maxLength 255
   */
  address_line1?: string;
  /**
   * Address Line2
   * @minLength 1
   * @maxLength 255
   */
  address_line2?: string;
  /**
   * City
   * @minLength 1
   * @maxLength 120
   */
  city?: string;
  /**
   * State
   * @minLength 1
   * @maxLength 120
   */
  state?: string;
  /**
   * Postcode
   * @minLength 1
   * @maxLength 20
   */
  postcode?: string;
  /** Is Active */
  is_active?: boolean;
  /**
   * Notes
   * @minLength 1
   * @maxLength 2000
   */
  notes?: string;
}

/** UpdatePartyResponse */
export interface UpdatePartyResponse {
  party: PartyResponse;
}

/** UpdatePolicyCoverageRequest */
export interface UpdatePolicyCoverageRequest {
  /**
   * Id
   * @exclusiveMin 0
   * @default 0
   */
  id?: number;
  /** An enumeration. */
  coverage_type?: CoverageType;
  /** Limit Amount */
  limit_amount?: number;
  /** Is Unlimited Coverage */
  is_unlimited_coverage?: boolean;
  /** Deductible Excess */
  deductible_excess?: number;
}

/** UpdatePolicyCoverageResponse */
export interface UpdatePolicyCoverageResponse {
  policy_coverage: PolicyCoverageResponse;
}

/** UpdateRegisterRequest */
export interface UpdateRegisterRequest {
  /**
   * Name of the register
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  /** ID of the register */
  id: number;
}

/** UpdateRegisterResponse */
export interface UpdateRegisterResponse {
  response: RegisterResponse;
}

/** UpdateReportTemplateRequest */
export interface UpdateReportTemplateRequest {
  /** Id */
  id: number;
  /** Name */
  name?: string;
  /** An enumeration. */
  type?: ReportType;
  /** An enumeration. */
  format?: ReportFormat;
  /** Assignee Ids */
  assignee_ids?: number[];
  /** Date Range */
  date_range?: string[];
  /** Task Ids */
  task_ids?: number[];
  /** Form Ids */
  form_ids?: number[];
  /** Register Ids */
  register_ids?: number[];
  /** Incident Type Ids */
  incident_type_ids?: number[];
  /** Client Id */
  client_id?: number;
  /** Is Favorite */
  is_favorite?: boolean;
  /** An enumeration. */
  status?: TaskResult;
}

/** UpdateReportTemplateResponse */
export interface UpdateReportTemplateResponse {
  report_template: ReportTemplateResponse;
}

/** UpdateScheduledMeetingResponse */
export interface UpdateScheduledMeetingResponse {
  /** Join Url */
  join_url?: string;
  /** Event Id */
  event_id?: string;
  /** Location */
  location?: string;
}

/** UpdateSecretRequest */
export interface UpdateSecretRequest {
  /** Secret Id */
  secret_id: number;
  /** Vault Id */
  vault_id: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Value
   * @minLength 1
   * @maxLength 50000
   */
  value: string;
}

/** UpdateSecretResponse */
export interface UpdateSecretResponse {
  secret: SecretResponse;
}

/** UpdateTagRequest */
export interface UpdateTagRequest {
  /**
   * Name of the tag
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** ID of the tag */
  id: number;
}

/** UpdateTagResponse */
export interface UpdateTagResponse {
  tag: TagResponse;
}

/** UpdateTaskPartiallyRequest */
export interface UpdateTaskPartiallyRequest {
  /** ID of the task */
  id: number;
  /**
   * The name of the task
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** An enumeration. */
  priority?: TaskPriority;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date?: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date?: string;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /** Is Every Employee Needs To Complete */
  is_every_employee_needs_to_complete?: boolean;
  /** id of the form */
  form_id?: number;
  /** description of the task */
  description?: string;
  /** Due Remainders */
  due_remainders?: CreateDueRemainderRequest[];
  /** User Ids */
  user_ids?: number[];
  /** Department Ids */
  department_ids?: number[];
  /** Incident Result Id */
  incident_result_id?: number;
}

/** UpdateTaskPartiallyResponse */
export interface UpdateTaskPartiallyResponse {
  task: TaskResponse;
}

/** UpdateTaskRequest */
export interface UpdateTaskRequest {
  /** ID of the task */
  id: number;
  /**
   * The name of the task
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** An enumeration. */
  priority?: TaskPriority;
  /**
   * First Due Date
   * @format date-time
   */
  first_due_date?: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date?: string;
  /** Recurrency Rule */
  recurrency_rule?: string;
  /**
   * Is Every Employee Needs To Complete
   * @default false
   */
  is_every_employee_needs_to_complete?: boolean;
  /** id of the form */
  form_id?: number;
  /** description of the task */
  description?: string;
  /**
   * Due Remainders
   * @default []
   */
  due_remainders?: CreateDueRemainderRequest[];
  /**
   * Users Overdue Subs
   * @default []
   */
  users_overdue_subs?: number[];
  /**
   * User Ids
   * @default []
   */
  user_ids?: number[];
  /**
   * Department Ids
   * @default []
   */
  department_ids?: number[];
  /**
   * Users Completed Subs
   * @default []
   */
  users_completed_subs?: number[];
  /** Incident Result Id */
  incident_result_id?: number;
  /**
   * Unassign Incident
   * @default false
   */
  unassign_incident?: boolean;
  /** Client Id */
  client_id?: number;
}

/** UpdateTaskResponse */
export interface UpdateTaskResponse {
  task: TaskResponse;
}

/** UpdateTaskResultRequest */
export interface UpdateTaskResultRequest {
  /** Unique Task result ID */
  id: number;
  /** Form Results */
  form_results?: object;
}

/** UpdateTaskResultResponse */
export interface UpdateTaskResultResponse {
  task_result: TaskResultResponse;
}

/** UpdateUserDocumentRequest */
export interface UpdateUserDocumentRequest {
  /** Document Id */
  document_id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Client Id */
  client_id?: number;
}

/** UpdateUserDocumentResponse */
export interface UpdateUserDocumentResponse {
  document: UserDocumentUpdateResponse;
}

/** UpdateUserRoleRequest */
export interface UpdateUserRoleRequest {
  /**
   * User Id
   * @exclusiveMin 0
   */
  user_id: number;
  /** An enumeration. */
  role: UserRole;
}

/** UpdateUserRoleResponse */
export interface UpdateUserRoleResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserTotpStatusRequest */
export interface UpdateUserTotpStatusRequest {
  /** Enabled */
  enabled: boolean;
}

/** UpdateUserTotpStatusResponse */
export interface UpdateUserTotpStatusResponse {
  /** Success */
  success: boolean;
}

/** UpdateVaultRequest */
export interface UpdateVaultRequest {
  /** Vault Id */
  vault_id: number;
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Description
   * @maxLength 5000
   */
  description?: string;
  /** Shared User Ids */
  shared_user_ids?: number[];
}

/** UpdateVaultResponse */
export interface UpdateVaultResponse {
  vault: VaultResponse;
}

/** UploadUserDocumentRequest */
export interface UploadUserDocumentRequest {
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** File Data */
  file_data: string;
  /** Folder Id */
  folder_id?: number;
  /** Client Id */
  client_id?: number;
}

/** UploadUserDocumentResponse */
export interface UploadUserDocumentResponse {
  /** Document Id */
  document_id: number;
  /** Object Key */
  object_key: string;
  /** Download Url */
  download_url: string;
}

/** User */
export interface User {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Avatar Url */
  avatar_url?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** UserBusinessResponse */
export interface UserBusinessResponse {
  /** Id */
  id: number;
  /** User Id */
  user_id: number;
  /** Business Id */
  business_id: number;
  business?: Business;
}

/** UserDepartmentSchema */
export interface UserDepartmentSchema {
  /** Department Id */
  department_id: number;
  /** User Id */
  user_id: number;
  /** Name */
  name: string;
}

/** UserDocumentChunk */
export interface UserDocumentChunk {
  /** Document Id */
  document_id: number;
  /** Chunk Order */
  chunk_order: number;
  /** Content */
  content: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
}

/** UserDocumentMinimalResponse */
export interface UserDocumentMinimalResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Client Id */
  client_id?: number;
}

/** UserDocumentResponse */
export interface UserDocumentResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Folder Id */
  folder_id?: number;
  /** Business Id */
  business_id: number;
  /** Uploaded By User Id */
  uploaded_by_user_id: number;
  /** File Storage Item Id */
  file_storage_item_id: string;
  /** Size */
  size?: number;
  /** Format */
  format?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /**
   * Public Document Id
   * @format uuid
   */
  public_document_id?: string;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
  /** Url */
  url?: string;
  /** Formatted Size */
  formatted_size: string;
  /** Content Type */
  content_type: string;
  /** Last Modified */
  last_modified?: string;
  /**
   * Chunks
   * @default []
   */
  chunks?: UserDocumentChunk[];
}

/** UserDocumentUpdateResponse */
export interface UserDocumentUpdateResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Folder Id */
  folder_id?: number;
  /** Business Id */
  business_id: number;
  /** Uploaded By User Id */
  uploaded_by_user_id: number;
  /** File Storage Item Id */
  file_storage_item_id: string;
  /** Size */
  size?: number;
  /** Format */
  format?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Parent Folder Name */
  parent_folder_name?: string;
  /**
   * Public Document Id
   * @format uuid
   */
  public_document_id?: string;
  /** Client Id */
  client_id?: number;
  client?: ClientMinimalResponse;
}

/** UserLookupResponse */
export interface UserLookupResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
}

/** UserMinimalResponse */
export interface UserMinimalResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
}

/** UserResponse */
export interface UserResponse {
  /** Id */
  id: number;
  /**
   * Email
   * @format email
   */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Avatar Storage Item Id */
  avatar_storage_item_id?: string;
  /** Is Enabled Tfa */
  is_enabled_tfa?: boolean;
  /** Avatar Url */
  avatar_url?: string;
  /**
   * Department
   * @default []
   */
  department?: UserDepartmentSchema[];
  /** @default [] */
  roles?: UserRole[];
  /** Keycloak User Id */
  keycloak_user_id?: string;
}

/** UserSchema */
export interface UserSchema {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** An enumeration. */
  role: UserRole;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** UsersByDepartmentResponse */
export interface UsersByDepartmentResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  /**
   * Users
   * @default []
   */
  users?: UserSchema[];
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VaultOwnerResponse */
export interface VaultOwnerResponse {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Avatar Url */
  avatar_url?: string;
}

/** VaultResponse */
export interface VaultResponse {
  /** Id */
  id: number;
  /** Business Id */
  business_id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Created By User Id */
  created_by_user_id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
  owner?: VaultOwnerResponse;
  /** Shared Users */
  shared_users?: SharedVaultUserResponse[];
}

/** WebhookEventsResponse */
export interface WebhookEventsResponse {
  /** Success */
  success: boolean;
}

/** Department */
export interface AppTasksDomainEntitiesDepartment {
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

/** Department */
export interface AppUsersDomainEntitiesDepartment {
  /** Name */
  name: string;
  /** Business Id */
  business_id: number;
  /**
   * Created With Ai
   * @default false
   */
  created_with_ai?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Id */
  id: number;
  /**
   * Deleted At
   * @format date-time
   */
  deleted_at?: string;
}

export interface GetUsersListV1UsersGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Exclude
   * @default ""
   */
  exclude?: string;
  /** An enumeration. */
  user_role?: UserRole;
}

export interface GetBusinessByIdV1UsersBusinessIdGetParams {
  /** Business Id */
  business_id: number;
  id: string;
}

export interface GetDepartmentsListV1DepartmentsGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
}

export interface GetDepartmentByIdV1DepartmentsIdGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetUsersByDepartmentV1DepartmentsUsersDepartmentIdGetParams {
  /** Department Id */
  departmentId: number;
}

export interface UpdateBusinessV1BusinessIdPatchParams {
  /** Id */
  id: number;
}

export interface GetFormListV1FormsGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Tag Ids
   * @default ""
   */
  filter_by_tag_ids?: string;
  /**
   * Filter By Deleted
   * @default false
   */
  filter_by_deleted?: boolean;
  /** Filter By Id */
  filter_by_id?: number | string;
}

export interface GetFormsItemsListV1FormsItemsGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter Key
   * @default ""
   */
  filter_key?: string;
  /**
   * Filter Value
   * @default ""
   */
  filter_value?: string;
}

export interface GetFormFieldsV1FormsFieldsByTaskOrIncidentGetParams {
  /** Task Id */
  task_id?: number;
  /** Incident Type Id */
  incident_type_id?: number;
}

export interface GetFormV1FormsIdGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface RemoveFormV1FormsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DeleteTagV1FormsTagsIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetTasksResultsItemsV1TasksResultItemsGetParams {
  /**
   * Page
   * @exclusiveMin 0
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @exclusiveMin 0
   * @default 10
   */
  page_size?: number;
  /**
   * User Id
   * @exclusiveMin 0
   */
  user_id?: number;
  /**
   * Form Id
   * @exclusiveMin 0
   */
  form_id?: number;
  /**
   * Task Id
   * @exclusiveMin 0
   */
  task_id?: number;
  /**
   * Register Id
   * @exclusiveMin 0
   */
  register_id?: number;
  /** Question Id */
  question_id?: string;
  /** An enumeration. */
  register_result?: RegisterResult;
  /**
   * From Date
   * @format date-time
   */
  from_date?: string;
  /**
   * To Date
   * @format date-time
   */
  to_date?: string;
}

export interface GetTaskListV1TasksGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /** Filter By Id */
  filter_by_id?: number | string;
  /**
   * Filter By Priority
   * @default ""
   */
  filter_by_priority?: string;
  /**
   * Filter By Result
   * @default ""
   */
  filter_by_result?: string;
  /**
   * Filter By Assignee Users
   * @default ""
   */
  filter_by_assignee_users?: string;
  /**
   * Filter By Assignee Departments
   * @default ""
   */
  filter_by_assignee_departments?: string;
  /**
   * Filter By Registers
   * @default ""
   */
  filter_by_registers?: string;
  /**
   * Filter By Form Ids
   * @default ""
   */
  filter_by_form_ids?: string;
  /** An enumeration. */
  filter_by_compliance_status?: RegisterResult;
  /** An enumeration. */
  filter_by_status?: TaskResult;
  /** Filter By Client Id */
  filter_by_client_id?: number;
  /**
   * Order By Due Date
   * @default false
   */
  order_by_due_date?: boolean;
  /**
   * Order By Priority
   * @default false
   */
  order_by_priority?: boolean;
  /**
   * From Date
   * @format date-time
   */
  from_date?: string;
  /**
   * To Date
   * @format date-time
   */
  to_date?: string;
  /** @default "todo" */
  mode?: TaskListMode;
  /**
   * Timezone
   * @default "Australia/Sydney"
   */
  timezone?: string;
}

export interface GetGraphicDataV1TasksGraphicDataGetParams {
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   */
  to_date: string;
}

export interface GetUpcomingTasksDataV1TasksUpcomingTasksChartGetParams {
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   */
  to_date: string;
  /**
   * Timezone
   * @default "Australia/Sydney"
   */
  timezone?: string;
}

export interface GetMonthStatisticsV1TasksMonthStatisticsGetParams {
  /**
   * From Date
   * @format date
   */
  from_date: string;
  /**
   * To Date
   * @format date
   */
  to_date: string;
}

export interface GetActivityLogListV1TasksActivityLogsGetParams {
  /** An enumeration. */
  type?: ActivityType;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /** Filter By Client Id */
  filter_by_client_id?: number;
  /** Filter By User Id */
  filter_by_user_id?: number;
  /** Filter By Recipient User Id */
  filter_by_recipient_user_id?: number;
  /** Filter By System */
  filter_by_system?: boolean;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

export interface GetTaskPublicAccessV1TasksPublicAccessGetParams {
  /**
   * Association
   * @format uuid
   */
  association: string;
  /**
   * Business Id
   * @exclusiveMin 0
   */
  business_id: number;
}

export interface GetTaskV1TasksIdGetParams {
  /** Client Id */
  client_id?: number;
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetTasksByIncidentResultV1TasksByIncidentResultIncidentResultIdGetParams {
  /**
   * Incident Result Id
   * @exclusiveMin 0
   */
  incidentResultId: number;
}

export interface DeleteTaskResultV1TasksResultIdDeleteParams {
  /** Id */
  id: number;
}

export interface ResendEmailToUserV1TasksResendEmailUserIdPostParams {
  /** User Id */
  userId: number;
}

export interface GetRegisterListV1RegistersGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /**
   * Filter By Deleted
   * @default false
   */
  filter_by_deleted?: boolean;
}

export interface GetRegisterListPublicV1RegistersPublicGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /**
   * Association
   * @format uuid
   */
  association: string;
  /** Business Id */
  business_id: number;
}

export interface GetRegisterV1RegistersIdGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface RemoveRegisterV1RegistersIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetReportListV1ReportsGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Format
   * @default ""
   */
  filter_by_format?: string;
  /**
   * Filter By Type
   * @default ""
   */
  filter_by_type?: string;
  /**
   * Filter By Created Date Start
   * @format date
   */
  filter_by_created_date_start?: string;
  /**
   * Filter By Created Date End
   * @format date
   */
  filter_by_created_date_end?: string;
  /** Batch Report Id */
  batch_report_id?: number;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetBatchReportsListV1ReportsBatchGetParams {
  /**
   * Page
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @default 10
   */
  page_size?: number;
  /**
   * Date From
   * @format date-time
   */
  date_from?: string;
  /**
   * Date To
   * @format date-time
   */
  date_to?: string;
  /** Filter By Template Id */
  filter_by_template_id?: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetBatchDetailsV1ReportsBatchIdGetParams {
  /**
   * Page
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @default 10
   */
  page_size?: number;
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DeleteBatchReportV1ReportsBatchIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DeleteReportFromBatchV1ReportsBatchBatchReportIdReportReportIdDeleteParams {
  /**
   * Report Id
   * @exclusiveMin 0
   */
  reportId: number;
  /**
   * Batch Report Id
   * @exclusiveMin 0
   */
  batchReportId: number;
}

export interface RemoveReportV1ReportsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetReportTemplatesListV1ReportsTemplatesGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetReportTemplateV1ReportsTemplateGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DeleteReportTemplateV1ReportsTemplatesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface DownloadBatchReportsV1ReportsBatchIdDownloadGetParams {
  /** Id */
  id: number;
}

export interface GetDocumentsV1UserDocumentsGetParams {
  /**
   * Page
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @default 20
   */
  page_size?: number;
  /** Filter By Id */
  filter_by_id?: number | string;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Format
   * @default ""
   */
  filter_by_format?: string;
  /** @default "created_at_desc" */
  sort_by?: DocumentSortBy;
  /**
   * From Date
   * @format date-time
   */
  from_date?: string;
  /**
   * To Date
   * @format date-time
   */
  to_date?: string;
  /** Folder Id */
  folder_id?: number;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetPublicFolderDocumentsV1UserDocumentsPublicFoldersDocumentsGetParams {
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id: string;
  /**
   * Page
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @default 20
   */
  page_size?: number;
  /** Filter By Id */
  filter_by_id?: number | string;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Format
   * @default ""
   */
  filter_by_format?: string;
  /** @default "created_at_desc" */
  sort_by?: DocumentSortBy;
  /**
   * From Date
   * @format date-time
   */
  from_date?: string;
  /**
   * To Date
   * @format date-time
   */
  to_date?: string;
  /** Folder Id */
  folder_id?: number;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetDocumentFolderTreeV1UserDocumentsFoldersTreeGetParams {
  /** Folder Id */
  folder_id?: number;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface GetPublicDocumentFolderTreeV1UserDocumentsFoldersPublicTreeGetParams {
  /**
   * Public Folder Id
   * @format uuid
   */
  public_folder_id: string;
}

export interface SearchDocumentsByContentV1UserDocumentsSearchGetParams {
  /** Query */
  query: string;
}

export interface DeleteDocumentV1UserDocumentsDocumentIdDeleteParams {
  /** Document Id */
  documentId: number;
}

export interface CreatePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkPostParams {
  /** Document Id */
  documentId: number;
}

export interface DeletePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkDeleteParams {
  /** Document Id */
  documentId: number;
}

export interface GetPublicDocumentV1UserDocumentsPublicPublicDocumentIdGetParams {
  /**
   * Public Document Id
   * @format uuid
   */
  publicDocumentId: string;
}

export interface GetDocumentTreeV1DocumentFoldersTreeGetParams {
  /** Folder Id */
  folder_id?: number;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface DeleteFolderV1DocumentFoldersFolderIdDeleteParams {
  /**
   * Force
   * @default false
   */
  force?: boolean;
  /** Folder Id */
  folderId: number;
}

export interface CreatePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkPostParams {
  /** Folder Id */
  folderId: number;
}

export interface DeletePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkDeleteParams {
  /** Folder Id */
  folderId: number;
}

export interface GetListV1IncidentTypesGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Priority
   * @default ""
   */
  filter_by_priority?: string;
  /**
   * Filter By Result
   * @default ""
   */
  filter_by_result?: string;
  /**
   * Order By Priority
   * @default false
   */
  order_by_priority?: boolean;
  /**
   * From Date
   * @format date
   */
  from_date?: string;
  /**
   * To Date
   * @format date
   */
  to_date?: string;
  /**
   * Filter By Deleted
   * @default false
   */
  filter_by_deleted?: boolean;
  /** Filter By Id */
  filter_by_id?: number | string;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface RemoveV1IncidentTypesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetListV1IncidentResultsGetParams {
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Filter By Id */
  filter_by_id?: number | string;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /** Filter By Completed By User Id */
  filter_by_completed_by_user_id?: number | string;
  /** Filter By Incident Type */
  filter_by_incident_type?: number | string;
  /** Filter By Created By User Id */
  filter_by_created_by_user_id?: number | string;
  /** Filter By Resolved By User Id */
  filter_by_resolved_by_user_id?: number | string;
  /**
   * Filter By Date Occurred From
   * @format date-time
   */
  filter_by_date_occurred_from?: string;
  /**
   * Filter By Date Occurred To
   * @format date-time
   */
  filter_by_date_occurred_to?: string;
  /**
   * Filter By Date Resolved From
   * @format date-time
   */
  filter_by_date_resolved_from?: string;
  /**
   * Filter By Date Resolved To
   * @format date-time
   */
  filter_by_date_resolved_to?: string;
  /** An enumeration. */
  filter_by_status?: IncidentResultStatus;
  /**
   * Filter By Deleted
   * @default false
   */
  filter_by_deleted?: boolean;
  /** Filter By Client Id */
  filter_by_client_id?: number;
}

export interface DeleteIncidentResultV1IncidentResultsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface CustomChartCalculationsV1CustomChartsCalculationsGetParams {
  /** Chart Id */
  chart_id: number;
  /**
   * From Date
   * @format date-time
   */
  from_date?: string;
  /**
   * To Date
   * @format date-time
   */
  to_date?: string;
}

export interface GetCustomChartListV1CustomChartsGetParams {
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
  /**
   * Filter By Deleted
   * @default false
   */
  filter_by_deleted?: boolean;
  /**
   * Page
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @default 10000
   */
  page_size?: number;
}

export interface GetCustomChartV1CustomChartsIdGetParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface RemoveCustomChartV1CustomChartsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface GetAiContextV1AiContextGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
}

export interface DeleteAiKnowledgeItemV1AiKnowledgeIdDeleteParams {
  /** Id */
  id: number;
}

export interface ListScheduledMeetingsV1MeetingsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 10
   */
  page_size?: number;
  /**
   * Search
   * @maxLength 255
   */
  search?: string;
}

export interface GetScheduledMeetingV1MeetingsMeetingIdGetParams {
  /** Meeting Id */
  meetingId: number;
}

export interface UpdateMeetingV1MeetingsMeetingIdPutParams {
  /** Meeting Id */
  meetingId: number;
}

export interface DeleteScheduledMeetingV1MeetingsMeetingIdDeleteParams {
  /** Meeting Id */
  meetingId: number;
}

export interface GetMeetingDocumentsV1MeetingsMeetingIdDocumentsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 10
   */
  page_size?: number;
  /** Meeting Id */
  meetingId: number;
}

export interface GetClientsListV1ClientsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /**
   * Filter By Name
   * @default ""
   */
  filter_by_name?: string;
}

export interface UpdateClientV1ClientsIdPutParams {
  /** Id */
  id: number;
}

export interface DeleteClientV1ClientsIdDeleteParams {
  /** Id */
  id: number;
}

export interface GetContractCreateLookupsV1ContractsLookupsCreateContractGetParams {
  /**
   * Users Page
   * @min 1
   * @default 1
   */
  users_page?: number;
  /**
   * Users Page Size
   * @min 1
   * @max 500
   * @default 100
   */
  users_page_size?: number;
  /**
   * Users Search
   * @maxLength 255
   * @default ""
   */
  users_search?: string;
  /**
   * Parties Page
   * @min 1
   * @default 1
   */
  parties_page?: number;
  /**
   * Parties Page Size
   * @min 1
   * @max 500
   * @default 100
   */
  parties_page_size?: number;
  /**
   * Jurisdictions Limit
   * @min 1
   * @max 1000
   * @default 300
   */
  jurisdictions_limit?: number;
  /**
   * Departments Limit
   * @min 1
   * @max 1000
   * @default 300
   */
  departments_limit?: number;
}

export interface GetJurisdictionsV1ContractsJurisdictionsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
}

export interface GetJurisdictionV1ContractsJurisdictionsIdGetParams {
  /** Id */
  id: number;
}

export interface DeleteJurisdictionV1ContractsJurisdictionsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdateJurisdictionV1ContractsJurisdictionsIdPatchParams {
  /** Id */
  id: number;
}

export interface GetPartiesV1ContractsPartiesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /**
   * Search
   * @minLength 1
   * @maxLength 255
   */
  search?: string;
  /**
   * Incorporation Country
   * @minLength 1
   * @maxLength 2
   */
  incorporation_country?: string;
  /**
   * State
   * @minLength 1
   * @maxLength 120
   */
  state?: string;
  /**
   * City
   * @minLength 1
   * @maxLength 120
   */
  city?: string;
  /** An enumeration. */
  verification_status?: ComplianceStatus;
  /**
   * Party Name
   * @minLength 1
   * @maxLength 255
   */
  party_name?: string;
}

export interface GetPartyV1ContractsPartiesIdGetParams {
  /** Id */
  id: number;
}

export interface DeletePartyV1ContractsPartiesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdatePartyV1ContractsPartiesIdPatchParams {
  /** Id */
  id: number;
}

export interface GetPartyContactsV1ContractsPartyContactsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Party Id */
  party_id?: number;
}

export interface GetPartyContactV1ContractsPartyContactsIdGetParams {
  /** Id */
  id: number;
}

export interface DeletePartyContactV1ContractsPartyContactsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdatePartyContactV1ContractsPartyContactsIdPatchParams {
  /** Id */
  id: number;
}

export interface GetPartyComplianceV1ContractsPartyComplianceGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Party Id */
  party_id?: number;
}

export interface GetPartyComplianceItemV1ContractsPartyComplianceIdGetParams {
  /** Id */
  id: number;
}

export interface DeletePartyComplianceV1ContractsPartyComplianceIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdatePartyComplianceV1ContractsPartyComplianceIdPatchParams {
  /** Id */
  id: number;
}

export interface GetContractPartiesV1ContractsContractPartiesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Contract Id */
  contract_id?: number;
}

export interface GetContractPartyV1ContractsContractPartiesIdGetParams {
  /** Id */
  id: number;
}

export interface DeleteContractPartyV1ContractsContractPartiesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdateContractPartyV1ContractsContractPartiesIdPatchParams {
  /** Id */
  id: number;
}

export interface GetContractContributorsV1ContractsContractContributorsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Contract Id */
  contract_id?: number;
}

export interface GetContractContributorV1ContractsContractContributorsIdGetParams {
  /** Id */
  id: number;
}

export interface DeleteContractContributorV1ContractsContractContributorsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdateContractContributorV1ContractsContractContributorsIdPatchParams {
  /** Id */
  id: number;
}

export interface GetPolicyCoveragesV1ContractsPolicyCoveragesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Contract Id */
  contract_id?: number;
}

export interface GetPolicyCoverageV1ContractsPolicyCoveragesIdGetParams {
  /** Id */
  id: number;
}

export interface DeletePolicyCoverageV1ContractsPolicyCoveragesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdatePolicyCoverageV1ContractsPolicyCoveragesIdPatchParams {
  /** Id */
  id: number;
}

export interface GetContractFilesV1ContractsContractFilesGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Contract Id */
  contract_id?: number;
}

export interface GetContractFileV1ContractsContractFilesIdGetParams {
  /** Id */
  id: number;
}

export interface DeleteContractFileV1ContractsContractFilesIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdateContractFileV1ContractsContractFilesIdPatchParams {
  /** Id */
  id: number;
}

export interface GetContractsV1ContractsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /** Department Id */
  department_id?: number;
  /** An enumeration. */
  status?: ContractStatus;
  /**
   * Search
   * @minLength 1
   * @maxLength 255
   */
  search?: string;
  /** Party Id */
  party_id?: number;
  /**
   * Expiry Date From
   * @format date
   */
  expiry_date_from?: string;
  /**
   * Expiry Date To
   * @format date
   */
  expiry_date_to?: string;
  /** An enumeration. */
  currency_code?: CurrencyCode;
  /** An enumeration. */
  category?: ContractCategory;
}

export interface GetContractV1ContractsIdGetParams {
  /** Id */
  id: number;
}

export interface DeleteContractV1ContractsIdDeleteParams {
  /**
   * Id
   * @exclusiveMin 0
   */
  id: number;
}

export interface UpdateContractV1ContractsIdPatchParams {
  /** Id */
  id: number;
}

export interface GetVaultsV1SecretManagerVaultsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 1
   */
  page_size?: number;
  /**
   * Search
   * @maxLength 255
   */
  search?: string;
}

export interface GetVaultV1SecretManagerVaultsVaultIdGetParams {
  /** Vault Id */
  vaultId: number;
}

export interface DeleteVaultV1SecretManagerVaultsVaultIdDeleteParams {
  /** Vault Id */
  vaultId: number;
}

export interface GetVaultSecretsV1SecretManagerVaultsVaultIdSecretsGetParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Page Size
   * @min 1
   * @max 100
   * @default 10
   */
  page_size?: number;
  /**
   * Search
   * @maxLength 255
   */
  search?: string;
  /** Vault Id */
  vaultId: number;
}

export interface DeleteSecretV1SecretManagerSecretsSecretIdDeleteParams {
  /**
   * Vault Id
   * @min 1
   */
  vault_id: number;
  /** Secret Id */
  secretId: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Compli One Compliance API
 * @version 1.0
 *
 * Compli One Compliance Backend REST API.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @tags users
     * @name GetUsersListV1UsersGet
     * @summary Get Users List
     * @request GET:/v1/users
     * @secure
     */
    getUsersListV1UsersGet: (
      query: GetUsersListV1UsersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserListResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name SignUpUserV1UsersPost
     * @summary Sign Up User
     * @request POST:/v1/users
     */
    signUpUserV1UsersPost: (
      data: SignUpUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<SignUpUserResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name RemoveUserV1UsersDelete
     * @summary Remove User
     * @request DELETE:/v1/users
     * @secure
     */
    removeUserV1UsersDelete: (
      data: DeleteUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name DeleteUserAvatarV1UsersAvatarDelete
     * @summary Delete User Avatar
     * @request DELETE:/v1/users/avatar
     * @secure
     */
    deleteUserAvatarV1UsersAvatarDelete: (params: RequestParams = {}) =>
      this.request<DeleteUserPhotoResponse, any>({
        path: `/v1/users/avatar`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name AddUserV1UsersAddUserPost
     * @summary Add User
     * @request POST:/v1/users/add-user
     * @secure
     */
    addUserV1UsersAddUserPost: (
      data: AddUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddUserResponse, HTTPValidationError>({
        path: `/v1/users/add-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetBusinessByIdV1UsersBusinessIdGet
     * @summary Get Business By Id
     * @request GET:/v1/users/business/{id}
     * @secure
     */
    getBusinessByIdV1UsersBusinessIdGet: (
      { id, ...query }: GetBusinessByIdV1UsersBusinessIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBusinessResponse, void | HTTPValidationError>({
        path: `/v1/users/business/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateBusinessV1UsersBusinessPatch
     * @summary Update Business
     * @request PATCH:/v1/users/business
     * @secure
     */
    updateBusinessV1UsersBusinessPatch: (
      data: UpdateBusinessRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBusinessResponse, HTTPValidationError>({
        path: `/v1/users/business`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetCurrentUserV1UsersCurrentGet
     * @summary Get Current User
     * @request GET:/v1/users/current
     * @secure
     */
    getCurrentUserV1UsersCurrentGet: (params: RequestParams = {}) =>
      this.request<GetCurrentUserResponse, any>({
        path: `/v1/users/current`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateCurrentUserV1UsersCurrentPatch
     * @summary Update Current User
     * @request PATCH:/v1/users/current
     * @secure
     */
    updateCurrentUserV1UsersCurrentPatch: (
      data: UpdateCurrentUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCurrentUserResponse, HTTPValidationError>({
        path: `/v1/users/current`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetUserBusinessV1UsersUserBusinessGet
     * @summary Get User Business
     * @request GET:/v1/users/user-business
     * @secure
     */
    getUserBusinessV1UsersUserBusinessGet: (params: RequestParams = {}) =>
      this.request<GetUserBusinessResponse, any>({
        path: `/v1/users/user-business`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for fully resetting a user's Two-Factor Authentication (2FA) configuration. This class allows a user to completely remove their existing TOTP-based 2FA setup, enabling them to reconfigure or add a new 2FA device from scratch. It retrieves the current authenticated user from the request context and calls the Users API to perform the reset operation.
     *
     * @tags users
     * @name ResetUser2FaV1UsersReset2FaPost
     * @summary Reset User 2Fa
     * @request POST:/v1/users/reset-2fa
     * @secure
     */
    resetUser2FaV1UsersReset2FaPost: (params: RequestParams = {}) =>
      this.request<ResetUserTotpResponse, any>({
        path: `/v1/users/reset-2fa`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Use case for enabling or disabling a user's Two-Factor Authentication (2FA) using Time-based One-Time Passwords (TOTP). This class retrieves the current authenticated user from the request context and calls the Users API to update the user's TOTP status. The operation allows the user to turn on or off their 2FA security feature.
     *
     * @tags users
     * @name UpdateUserTotpStatusV1UsersOtpPost
     * @summary Update User Totp Status
     * @request POST:/v1/users/otp
     * @secure
     */
    updateUserTotpStatusV1UsersOtpPost: (
      data: UpdateUserTotpStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserTotpStatusResponse, HTTPValidationError>({
        path: `/v1/users/otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateUserRoleV1UsersUserRolePut
     * @summary Update User Role
     * @request PUT:/v1/users/user-role
     * @secure
     */
    updateUserRoleV1UsersUserRolePut: (
      data: UpdateUserRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserRoleResponse, HTTPValidationError>({
        path: `/v1/users/user-role`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name GetDepartmentsListV1DepartmentsGet
     * @summary Get Departments List
     * @request GET:/v1/departments
     * @secure
     */
    getDepartmentsListV1DepartmentsGet: (
      query: GetDepartmentsListV1DepartmentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDepartmentListResponse, HTTPValidationError>({
        path: `/v1/departments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name CreateDepartmentV1DepartmentsPost
     * @summary Create Department
     * @request POST:/v1/departments
     * @secure
     */
    createDepartmentV1DepartmentsPost: (
      data: CreateDepartmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateDepartmentResponse, HTTPValidationError>({
        path: `/v1/departments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name RemoveDepartmentV1DepartmentsDelete
     * @summary Remove Department
     * @request DELETE:/v1/departments
     * @secure
     */
    removeDepartmentV1DepartmentsDelete: (
      data: DeleteDepartmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDepartmentResponse, HTTPValidationError>({
        path: `/v1/departments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name UpdateDepartmentV1DepartmentsPatch
     * @summary Update Department
     * @request PATCH:/v1/departments
     * @secure
     */
    updateDepartmentV1DepartmentsPatch: (
      data: UpdateDepartmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDepartmentResponse, HTTPValidationError>({
        path: `/v1/departments`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name GetDepartmentByIdV1DepartmentsIdGet
     * @summary Get Department By Id
     * @request GET:/v1/departments/{id}
     * @secure
     */
    getDepartmentByIdV1DepartmentsIdGet: (
      { id }: GetDepartmentByIdV1DepartmentsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDepartmentResponse, void | HTTPValidationError>({
        path: `/v1/departments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name GetUsersByDepartmentV1DepartmentsUsersDepartmentIdGet
     * @summary Get Users By Department
     * @request GET:/v1/departments/users/{department_id}
     * @secure
     */
    getUsersByDepartmentV1DepartmentsUsersDepartmentIdGet: (
      {
        departmentId,
      }: GetUsersByDepartmentV1DepartmentsUsersDepartmentIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersByDepartmentResponse, void | HTTPValidationError>({
        path: `/v1/departments/users/${departmentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name AddUsersToDepartmentV1DepartmentsUsersPost
     * @summary Add Users To Department
     * @request POST:/v1/departments/users
     * @secure
     */
    addUsersToDepartmentV1DepartmentsUsersPost: (
      data: CreateDepartmentUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateDepartmentUserResponse, HTTPValidationError>({
        path: `/v1/departments/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags departments
     * @name DeleteUsersFromDepartmentV1DepartmentsUsersDelete
     * @summary Delete Users From Department
     * @request DELETE:/v1/departments/users
     * @secure
     */
    deleteUsersFromDepartmentV1DepartmentsUsersDelete: (
      data: DeleteDepartmentUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDepartmentUserResponse, HTTPValidationError>({
        path: `/v1/departments/users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags business
     * @name DeleteFromBusinessV1BusinessPost
     * @summary Delete From Business
     * @request POST:/v1/business
     * @secure
     */
    deleteFromBusinessV1BusinessPost: (
      data: DeleteUserBusinessRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserBusinessResponse, HTTPValidationError>({
        path: `/v1/business`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags business
     * @name UpdateBusinessV1BusinessIdPatch
     * @summary Update Business
     * @request PATCH:/v1/business/{id}
     * @secure
     */
    updateBusinessV1BusinessIdPatch: (
      { id }: UpdateBusinessV1BusinessIdPatchParams,
      data: UpdateBusinessRequestBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBusinessResponse, HTTPValidationError>({
        path: `/v1/business/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name GetFormListV1FormsGet
     * @summary Get Form List
     * @request GET:/v1/forms
     * @secure
     */
    getFormListV1FormsGet: (
      query: GetFormListV1FormsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetFormListResponse, HTTPValidationError>({
        path: `/v1/forms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name CreateFormV1FormsPost
     * @summary Create Form
     * @request POST:/v1/forms
     * @secure
     */
    createFormV1FormsPost: (
      data: CreateFormRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateFormResponse, HTTPValidationError>({
        path: `/v1/forms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name UpdateFormV1FormsPatch
     * @summary Update Form
     * @request PATCH:/v1/forms
     * @secure
     */
    updateFormV1FormsPatch: (
      data: UpdateFormRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFormResponse, void | HTTPValidationError>({
        path: `/v1/forms`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name GetFormsItemsListV1FormsItemsGet
     * @summary Get Forms Items List
     * @request GET:/v1/forms/items
     * @secure
     */
    getFormsItemsListV1FormsItemsGet: (
      query: GetFormsItemsListV1FormsItemsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetFormsItemsListResponse, HTTPValidationError>({
        path: `/v1/forms/items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name GetFormFieldsV1FormsFieldsByTaskOrIncidentGet
     * @summary Get Form Fields
     * @request GET:/v1/forms/fields-by-task-or-incident
     * @secure
     */
    getFormFieldsV1FormsFieldsByTaskOrIncidentGet: (
      query: GetFormFieldsV1FormsFieldsByTaskOrIncidentGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetFormFieldsResponse, HTTPValidationError>({
        path: `/v1/forms/fields-by-task-or-incident`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name GetTagsListV1FormsTagsGet
     * @summary Get Tags List
     * @request GET:/v1/forms/tags
     * @secure
     */
    getTagsListV1FormsTagsGet: (params: RequestParams = {}) =>
      this.request<GetTagsListResponse, any>({
        path: `/v1/forms/tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name CreateTagV1FormsTagsPost
     * @summary Create Tag
     * @request POST:/v1/forms/tags
     * @secure
     */
    createTagV1FormsTagsPost: (
      data: CreateTagRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTagResponse, HTTPValidationError>({
        path: `/v1/forms/tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name UpdateTagV1FormsTagsPatch
     * @summary Update Tag
     * @request PATCH:/v1/forms/tags
     * @secure
     */
    updateTagV1FormsTagsPatch: (
      data: UpdateTagRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTagResponse, HTTPValidationError>({
        path: `/v1/forms/tags`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name GetFormV1FormsIdGet
     * @summary Get Form
     * @request GET:/v1/forms/{id}
     * @secure
     */
    getFormV1FormsIdGet: (
      { id }: GetFormV1FormsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetFormResponse, void | HTTPValidationError>({
        path: `/v1/forms/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name RemoveFormV1FormsIdDelete
     * @summary Remove Form
     * @request DELETE:/v1/forms/{id}
     * @secure
     */
    removeFormV1FormsIdDelete: (
      { id }: RemoveFormV1FormsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteFormResponse, HTTPValidationError>({
        path: `/v1/forms/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name RestoreFormV1FormsRestorePost
     * @summary Restore Form
     * @request POST:/v1/forms/restore
     * @secure
     */
    restoreFormV1FormsRestorePost: (
      data: RestoreFormRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreFormResponse, HTTPValidationError>({
        path: `/v1/forms/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name DeleteTagV1FormsTagsIdDelete
     * @summary Delete Tag
     * @request DELETE:/v1/forms/tags/{id}
     * @secure
     */
    deleteTagV1FormsTagsIdDelete: (
      { id }: DeleteTagV1FormsTagsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTagResponse, HTTPValidationError>({
        path: `/v1/forms/tags/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTasksResultsItemsV1TasksResultItemsGet
     * @summary Get Tasks Results Items
     * @request GET:/v1/tasks/result-items
     * @secure
     */
    getTasksResultsItemsV1TasksResultItemsGet: (
      query: GetTasksResultsItemsV1TasksResultItemsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTasksResultsItemsResponse, HTTPValidationError>({
        path: `/v1/tasks/result-items`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTaskListV1TasksGet
     * @summary Get Task List
     * @request GET:/v1/tasks
     * @secure
     */
    getTaskListV1TasksGet: (
      query: GetTaskListV1TasksGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTaskListResponse, HTTPValidationError>({
        path: `/v1/tasks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name CreateTaskV1TasksPost
     * @summary Create Task
     * @request POST:/v1/tasks
     * @secure
     */
    createTaskV1TasksPost: (
      data: CreateTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTaskResponse, HTTPValidationError>({
        path: `/v1/tasks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name DeleteTaskV1TasksDelete
     * @summary Delete Task
     * @request DELETE:/v1/tasks
     * @secure
     */
    deleteTaskV1TasksDelete: (
      data: DeleteTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTaskResponse, HTTPValidationError>({
        path: `/v1/tasks`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name UpdateTaskV1TasksPatch
     * @summary Update Task
     * @request PATCH:/v1/tasks
     * @secure
     */
    updateTaskV1TasksPatch: (
      data: UpdateTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTaskResponse, HTTPValidationError>({
        path: `/v1/tasks`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name CreateQuickTaskV1TasksQuickTaskPost
     * @summary Create Quick Task
     * @request POST:/v1/tasks/quick-task
     * @secure
     */
    createQuickTaskV1TasksQuickTaskPost: (
      data: CreateQuickTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateQuickTaskResponse, HTTPValidationError>({
        path: `/v1/tasks/quick-task`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name UpdateTaskPartiallyV1TasksPartiallyPatch
     * @summary Update Task Partially
     * @request PATCH:/v1/tasks/partially
     * @secure
     */
    updateTaskPartiallyV1TasksPartiallyPatch: (
      data: UpdateTaskPartiallyRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTaskPartiallyResponse, HTTPValidationError>({
        path: `/v1/tasks/partially`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name AddUsersToTaskV1TasksUsersPost
     * @summary Add Users To Task
     * @request POST:/v1/tasks/users
     * @secure
     */
    addUsersToTaskV1TasksUsersPost: (
      data: CreateTaskUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTaskUserResponse, HTTPValidationError>({
        path: `/v1/tasks/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name DeleteUsersFromTaskV1TasksUsersDelete
     * @summary Delete Users From Task
     * @request DELETE:/v1/tasks/users
     * @secure
     */
    deleteUsersFromTaskV1TasksUsersDelete: (
      data: DeleteTaskUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTaskUserResponse, HTTPValidationError>({
        path: `/v1/tasks/users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name AddDepartmentsToTaskV1TasksDepartmentsPost
     * @summary Add Departments To Task
     * @request POST:/v1/tasks/departments
     * @secure
     */
    addDepartmentsToTaskV1TasksDepartmentsPost: (
      data: CreateTaskDepartmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTaskDepartmentResponse, HTTPValidationError>({
        path: `/v1/tasks/departments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name DeleteDepartmentsFromTaskV1TasksDepartmentsDelete
     * @summary Delete Departments From Task
     * @request DELETE:/v1/tasks/departments
     * @secure
     */
    deleteDepartmentsFromTaskV1TasksDepartmentsDelete: (
      data: DeleteTaskDepartmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTaskUserResponse, HTTPValidationError>({
        path: `/v1/tasks/departments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetGraphicDataV1TasksGraphicDataGet
     * @summary Get Graphic Data
     * @request GET:/v1/tasks/graphic-data
     * @secure
     */
    getGraphicDataV1TasksGraphicDataGet: (
      query: GetGraphicDataV1TasksGraphicDataGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDashboardGraphicDataResponse, HTTPValidationError>({
        path: `/v1/tasks/graphic-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetUpcomingTasksDataV1TasksUpcomingTasksChartGet
     * @summary Get Upcoming Tasks Data
     * @request GET:/v1/tasks/upcoming-tasks-chart
     * @secure
     */
    getUpcomingTasksDataV1TasksUpcomingTasksChartGet: (
      query: GetUpcomingTasksDataV1TasksUpcomingTasksChartGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUpcomingTaskChartResponse, HTTPValidationError>({
        path: `/v1/tasks/upcoming-tasks-chart`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetMonthStatisticsV1TasksMonthStatisticsGet
     * @summary Get Month Statistics
     * @request GET:/v1/tasks/month-statistics
     * @secure
     */
    getMonthStatisticsV1TasksMonthStatisticsGet: (
      query: GetMonthStatisticsV1TasksMonthStatisticsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetMonthStatisticsResponse, HTTPValidationError>({
        path: `/v1/tasks/month-statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetActivityLogListV1TasksActivityLogsGet
     * @summary Get Activity Log List
     * @request GET:/v1/tasks/activity-logs
     * @secure
     */
    getActivityLogListV1TasksActivityLogsGet: (
      query: GetActivityLogListV1TasksActivityLogsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetActivityLogListResponse, HTTPValidationError>({
        path: `/v1/tasks/activity-logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTaskPublicAccessV1TasksPublicAccessGet
     * @summary Get Task Public Access
     * @request GET:/v1/tasks/public-access
     */
    getTaskPublicAccessV1TasksPublicAccessGet: (
      query: GetTaskPublicAccessV1TasksPublicAccessGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTaskPublicAccessResponse, HTTPValidationError>({
        path: `/v1/tasks/public-access`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTaskV1TasksIdGet
     * @summary Get Task
     * @request GET:/v1/tasks/{id}
     * @secure
     */
    getTaskV1TasksIdGet: (
      { id, ...query }: GetTaskV1TasksIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTaskResponse, HTTPValidationError>({
        path: `/v1/tasks/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTasksByIncidentResultV1TasksByIncidentResultIncidentResultIdGet
     * @summary Get Tasks By Incident Result
     * @request GET:/v1/tasks/by-incident-result/{incident_result_id}
     * @secure
     */
    getTasksByIncidentResultV1TasksByIncidentResultIncidentResultIdGet: (
      {
        incidentResultId,
      }: GetTasksByIncidentResultV1TasksByIncidentResultIncidentResultIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTasksByIncidentResponse, HTTPValidationError>({
        path: `/v1/tasks/by-incident-result/${incidentResultId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name CreateTaskResultV1TasksResultPost
     * @summary Create Task Result
     * @request POST:/v1/tasks/result
     * @secure
     */
    createTaskResultV1TasksResultPost: (
      data: CreateTaskResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateTaskResultResponse, HTTPValidationError>({
        path: `/v1/tasks/result`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name UpdateTaskResultV1TasksResultPatch
     * @summary Update Task Result
     * @request PATCH:/v1/tasks/result
     * @secure
     */
    updateTaskResultV1TasksResultPatch: (
      data: UpdateTaskResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTaskResultResponse, HTTPValidationError>({
        path: `/v1/tasks/result`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name DeleteTaskResultV1TasksResultIdDelete
     * @summary Delete Task Result
     * @request DELETE:/v1/tasks/result/{id}
     * @secure
     */
    deleteTaskResultV1TasksResultIdDelete: (
      { id }: DeleteTaskResultV1TasksResultIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTaskResultResponse, HTTPValidationError>({
        path: `/v1/tasks/result/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name RestoreTaskResultV1TasksResultRestorePost
     * @summary Restore Task Result
     * @request POST:/v1/tasks/result/restore
     * @secure
     */
    restoreTaskResultV1TasksResultRestorePost: (
      data: RestoreTaskResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreTaskResultResponse, HTTPValidationError>({
        path: `/v1/tasks/result/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name PublicAccessCreateTaskResultV1TasksPublicAccessResultPost
     * @summary Public Access Create Task Result
     * @request POST:/v1/tasks/public-access/result
     */
    publicAccessCreateTaskResultV1TasksPublicAccessResultPost: (
      data: PublicAccessCreateTaskResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<PublicAccessCreateTaskResultResponse, HTTPValidationError>({
        path: `/v1/tasks/public-access/result`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name BulkCreatePublicLinksV1TasksBulkCreatePublicLinksPost
     * @summary Bulk Create Public Links
     * @request POST:/v1/tasks/bulk-create-public-links
     * @secure
     */
    bulkCreatePublicLinksV1TasksBulkCreatePublicLinksPost: (
      data: BulkCreatePublicLinksRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkCreatePublicLinksResponse, HTTPValidationError>({
        path: `/v1/tasks/bulk-create-public-links`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name BulkSendStartDateEmailsV1TasksBulkSendStartDateEmailsPost
     * @summary Bulk Send Start Date Emails
     * @request POST:/v1/tasks/bulk-send-start-date-emails
     * @secure
     */
    bulkSendStartDateEmailsV1TasksBulkSendStartDateEmailsPost: (
      data: BulkSendStartDateEmailsRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkSendStartDateEmailsResponse, HTTPValidationError>({
        path: `/v1/tasks/bulk-send-start-date-emails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name RestoreTaskV1TasksRestorePost
     * @summary Restore Task
     * @request POST:/v1/tasks/restore
     * @secure
     */
    restoreTaskV1TasksRestorePost: (
      data: RestoreTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreTaskResponse, HTTPValidationError>({
        path: `/v1/tasks/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name ResendEmailToUserV1TasksResendEmailUserIdPost
     * @summary Resend Email To User
     * @request POST:/v1/tasks/resend-email/{user_id}
     * @secure
     */
    resendEmailToUserV1TasksResendEmailUserIdPost: (
      { userId }: ResendEmailToUserV1TasksResendEmailUserIdPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ResendEmailResponse, HTTPValidationError>({
        path: `/v1/tasks/resend-email/${userId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name GetRegisterListV1RegistersGet
     * @summary Get Register List
     * @request GET:/v1/registers
     * @secure
     */
    getRegisterListV1RegistersGet: (
      query: GetRegisterListV1RegistersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterListResponse, HTTPValidationError>({
        path: `/v1/registers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name CreateRegisterV1RegistersPost
     * @summary Create Register
     * @request POST:/v1/registers
     * @secure
     */
    createRegisterV1RegistersPost: (
      data: CreateRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateRegisterResponse, HTTPValidationError>({
        path: `/v1/registers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name UpdateRegisterV1RegistersPatch
     * @summary Update Register
     * @request PATCH:/v1/registers
     * @secure
     */
    updateRegisterV1RegistersPatch: (
      data: UpdateRegisterRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegisterResponse, void | HTTPValidationError>({
        path: `/v1/registers`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name GetRegisterListPublicV1RegistersPublicGet
     * @summary Get Register List Public
     * @request GET:/v1/registers/public
     */
    getRegisterListPublicV1RegistersPublicGet: (
      query: GetRegisterListPublicV1RegistersPublicGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterListPublicAccessResponse, HTTPValidationError>({
        path: `/v1/registers/public`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name GetRegisterV1RegistersIdGet
     * @summary Get Register
     * @request GET:/v1/registers/{id}
     * @secure
     */
    getRegisterV1RegistersIdGet: (
      { id }: GetRegisterV1RegistersIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegisterResponse, void | HTTPValidationError>({
        path: `/v1/registers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags registers
     * @name RemoveRegisterV1RegistersIdDelete
     * @summary Remove Register
     * @request DELETE:/v1/registers/{id}
     * @secure
     */
    removeRegisterV1RegistersIdDelete: (
      { id }: RemoveRegisterV1RegistersIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteRegisterResponse, HTTPValidationError>({
        path: `/v1/registers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GetReportListV1ReportsGet
     * @summary Get Report List
     * @request GET:/v1/reports
     * @secure
     */
    getReportListV1ReportsGet: (
      query: GetReportListV1ReportsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetReportListResponse, HTTPValidationError>({
        path: `/v1/reports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name CreateReportV1ReportsPost
     * @summary Create Report
     * @request POST:/v1/reports
     * @secure
     */
    createReportV1ReportsPost: (
      data: CreateReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateReportResponse, HTTPValidationError>({
        path: `/v1/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GetBatchReportsListV1ReportsBatchGet
     * @summary Get Batch Reports List
     * @request GET:/v1/reports/batch
     * @secure
     */
    getBatchReportsListV1ReportsBatchGet: (
      query: GetBatchReportsListV1ReportsBatchGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBatchReportsListResponse, HTTPValidationError>({
        path: `/v1/reports/batch`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name CreateBatchReportV1ReportsBatchPost
     * @summary Create Batch Report
     * @request POST:/v1/reports/batch
     * @secure
     */
    createBatchReportV1ReportsBatchPost: (
      data: CreateBatchReportsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBatchReportsResponse, HTTPValidationError>({
        path: `/v1/reports/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name UpdateBatchReportV1ReportsBatchPatch
     * @summary Update Batch Report
     * @request PATCH:/v1/reports/batch
     * @secure
     */
    updateBatchReportV1ReportsBatchPatch: (
      data: UpdateBatchReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBatchReportResponse, HTTPValidationError>({
        path: `/v1/reports/batch`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GenerateBatchReportV1ReportsGenerateBatchPost
     * @summary Generate Batch Report
     * @request POST:/v1/reports/generate-batch
     * @secure
     */
    generateBatchReportV1ReportsGenerateBatchPost: (
      data: GenerateBatchReportsRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenerateBatchReportsResponse, HTTPValidationError>({
        path: `/v1/reports/generate-batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GetBatchDetailsV1ReportsBatchIdGet
     * @summary Get Batch Details
     * @request GET:/v1/reports/batch/{id}
     * @secure
     */
    getBatchDetailsV1ReportsBatchIdGet: (
      { id, ...query }: GetBatchDetailsV1ReportsBatchIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBatchDetailsResponse, HTTPValidationError>({
        path: `/v1/reports/batch/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name DeleteBatchReportV1ReportsBatchIdDelete
     * @summary Delete Batch Report
     * @request DELETE:/v1/reports/batch/{id}
     * @secure
     */
    deleteBatchReportV1ReportsBatchIdDelete: (
      { id }: DeleteBatchReportV1ReportsBatchIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteBatchReportsResponse, HTTPValidationError>({
        path: `/v1/reports/batch/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name DeleteReportFromBatchV1ReportsBatchBatchReportIdReportReportIdDelete
     * @summary Delete Report From Batch
     * @request DELETE:/v1/reports/batch/{batch_report_id}/report/{report_id}
     * @secure
     */
    deleteReportFromBatchV1ReportsBatchBatchReportIdReportReportIdDelete: (
      {
        reportId,
        batchReportId,
      }: DeleteReportFromBatchV1ReportsBatchBatchReportIdReportReportIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteReportFromBatchResponse, HTTPValidationError>({
        path: `/v1/reports/batch/${batchReportId}/report/${reportId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name RemoveReportV1ReportsIdDelete
     * @summary Remove Report
     * @request DELETE:/v1/reports/{id}
     * @secure
     */
    removeReportV1ReportsIdDelete: (
      { id }: RemoveReportV1ReportsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteReportResponse, HTTPValidationError>({
        path: `/v1/reports/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GetReportTemplatesListV1ReportsTemplatesGet
     * @summary Get Report Templates List
     * @request GET:/v1/reports/templates
     * @secure
     */
    getReportTemplatesListV1ReportsTemplatesGet: (
      query: GetReportTemplatesListV1ReportsTemplatesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetReportTemplatesListResponse, HTTPValidationError>({
        path: `/v1/reports/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name CreateReportTemplateV1ReportsTemplatesPost
     * @summary Create Report Template
     * @request POST:/v1/reports/templates
     * @secure
     */
    createReportTemplateV1ReportsTemplatesPost: (
      data: CreateReportTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateReportTemplateResponse, HTTPValidationError>({
        path: `/v1/reports/templates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name GetReportTemplateV1ReportsTemplateGet
     * @summary Get Report Template
     * @request GET:/v1/reports/template
     * @secure
     */
    getReportTemplateV1ReportsTemplateGet: (
      query: GetReportTemplateV1ReportsTemplateGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetReportTemplateResponse, HTTPValidationError>({
        path: `/v1/reports/template`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name UpdateReportTemplateV1ReportsTemplatePatch
     * @summary Update Report Template
     * @request PATCH:/v1/reports/template
     * @secure
     */
    updateReportTemplateV1ReportsTemplatePatch: (
      data: UpdateReportTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateReportTemplateResponse, HTTPValidationError>({
        path: `/v1/reports/template`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name DeleteReportTemplateV1ReportsTemplatesIdDelete
     * @summary Delete Report Template
     * @request DELETE:/v1/reports/templates/{id}
     * @secure
     */
    deleteReportTemplateV1ReportsTemplatesIdDelete: (
      { id }: DeleteReportTemplateV1ReportsTemplatesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteReportTemplateResponse, HTTPValidationError>({
        path: `/v1/reports/templates/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name DownloadBatchReportsV1ReportsBatchIdDownloadGet
     * @summary Download Batch Reports
     * @request GET:/v1/reports/batch/{id}/download
     * @secure
     */
    downloadBatchReportsV1ReportsBatchIdDownloadGet: (
      { id }: DownloadBatchReportsV1ReportsBatchIdDownloadGetParams,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/reports/batch/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reports
     * @name DownloadCombinedBatchReportsV1ReportsBatchCombinedPost
     * @summary Download Combined Batch Reports
     * @request POST:/v1/reports/batch/combined
     * @secure
     */
    downloadCombinedBatchReportsV1ReportsBatchCombinedPost: (
      data: DownloadMergedBatchReportsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DownloadMergedBatchReportsResponse, HTTPValidationError>({
        path: `/v1/reports/batch/combined`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name UploadDocumentV1UserDocumentsUploadPost
     * @summary Upload Document
     * @request POST:/v1/user-documents/upload
     * @secure
     */
    uploadDocumentV1UserDocumentsUploadPost: (
      data: UploadUserDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadUserDocumentResponse, HTTPValidationError>({
        path: `/v1/user-documents/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetDocumentsV1UserDocumentsGet
     * @summary Get Documents
     * @request GET:/v1/user-documents
     * @secure
     */
    getDocumentsV1UserDocumentsGet: (
      query: GetDocumentsV1UserDocumentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserDocumentsResponse, HTTPValidationError>({
        path: `/v1/user-documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name UpdateDocumentV1UserDocumentsPatch
     * @summary Update Document
     * @request PATCH:/v1/user-documents
     * @secure
     */
    updateDocumentV1UserDocumentsPatch: (
      data: UpdateUserDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserDocumentResponse, HTTPValidationError>({
        path: `/v1/user-documents`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetPublicFolderDocumentsV1UserDocumentsPublicFoldersDocumentsGet
     * @summary Get Public Folder Documents
     * @request GET:/v1/user-documents/public-folders/documents
     */
    getPublicFolderDocumentsV1UserDocumentsPublicFoldersDocumentsGet: (
      query: GetPublicFolderDocumentsV1UserDocumentsPublicFoldersDocumentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPublicUserDocumentsResponse, HTTPValidationError>({
        path: `/v1/user-documents/public-folders/documents`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetDocumentFolderTreeV1UserDocumentsFoldersTreeGet
     * @summary Get Document Folder Tree
     * @request GET:/v1/user-documents/folders/tree
     * @secure
     */
    getDocumentFolderTreeV1UserDocumentsFoldersTreeGet: (
      query: GetDocumentFolderTreeV1UserDocumentsFoldersTreeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDocumentFolderTreeResponse, HTTPValidationError>({
        path: `/v1/user-documents/folders/tree`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetPublicDocumentFolderTreeV1UserDocumentsFoldersPublicTreeGet
     * @summary Get Public Document Folder Tree
     * @request GET:/v1/user-documents/folders/public-tree
     */
    getPublicDocumentFolderTreeV1UserDocumentsFoldersPublicTreeGet: (
      query: GetPublicDocumentFolderTreeV1UserDocumentsFoldersPublicTreeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPublicDocumentFolderTreeResponse, HTTPValidationError>({
        path: `/v1/user-documents/folders/public-tree`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetAllDocumentsV1UserDocumentsAllGet
     * @summary Get All Documents
     * @request GET:/v1/user-documents/all
     * @secure
     */
    getAllDocumentsV1UserDocumentsAllGet: (params: RequestParams = {}) =>
      this.request<GetAllUserDocumentsResponse, any>({
        path: `/v1/user-documents/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name SearchDocumentsByContentV1UserDocumentsSearchGet
     * @summary Search Documents By Content
     * @request GET:/v1/user-documents/search
     * @secure
     */
    searchDocumentsByContentV1UserDocumentsSearchGet: (
      query: SearchDocumentsByContentV1UserDocumentsSearchGetParams,
      params: RequestParams = {},
    ) =>
      this.request<SearchUserDocumentsByContentResponse, HTTPValidationError>({
        path: `/v1/user-documents/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name DeleteDocumentV1UserDocumentsDocumentIdDelete
     * @summary Delete Document
     * @request DELETE:/v1/user-documents/{document_id}
     * @secure
     */
    deleteDocumentV1UserDocumentsDocumentIdDelete: (
      { documentId }: DeleteDocumentV1UserDocumentsDocumentIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserDocumentResponse, HTTPValidationError>({
        path: `/v1/user-documents/${documentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name CreatePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkPost
     * @summary Create Public Document Link
     * @request POST:/v1/user-documents/{document_id}/public-link
     * @secure
     */
    createPublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkPost: (
      {
        documentId,
      }: CreatePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkPostParams,
      params: RequestParams = {},
    ) =>
      this.request<CreatePublicDocumentLinkResponse, HTTPValidationError>({
        path: `/v1/user-documents/${documentId}/public-link`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name DeletePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkDelete
     * @summary Delete Public Document Link
     * @request DELETE:/v1/user-documents/{document_id}/public-link
     * @secure
     */
    deletePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkDelete: (
      {
        documentId,
      }: DeletePublicDocumentLinkV1UserDocumentsDocumentIdPublicLinkDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePublicDocumentLinkResponse, HTTPValidationError>({
        path: `/v1/user-documents/${documentId}/public-link`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user documents
     * @name GetPublicDocumentV1UserDocumentsPublicPublicDocumentIdGet
     * @summary Get Public Document
     * @request GET:/v1/user-documents/public/{public_document_id}
     */
    getPublicDocumentV1UserDocumentsPublicPublicDocumentIdGet: (
      {
        publicDocumentId,
      }: GetPublicDocumentV1UserDocumentsPublicPublicDocumentIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPublicUserDocumentResponse, HTTPValidationError>({
        path: `/v1/user-documents/public/${publicDocumentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name CreateFolderV1DocumentFoldersPost
     * @summary Create Folder
     * @request POST:/v1/document-folders
     * @secure
     */
    createFolderV1DocumentFoldersPost: (
      data: CreateFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateFolderResponse, HTTPValidationError>({
        path: `/v1/document-folders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name UpdateFolderV1DocumentFoldersPatch
     * @summary Update Folder
     * @request PATCH:/v1/document-folders
     * @secure
     */
    updateFolderV1DocumentFoldersPatch: (
      data: UpdateFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFolderRequest, HTTPValidationError>({
        path: `/v1/document-folders`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name GetDocumentTreeV1DocumentFoldersTreeGet
     * @summary Get Document Tree
     * @request GET:/v1/document-folders/tree
     * @secure
     */
    getDocumentTreeV1DocumentFoldersTreeGet: (
      query: GetDocumentTreeV1DocumentFoldersTreeGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDocumentTreeResponse, HTTPValidationError>({
        path: `/v1/document-folders/tree`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name MoveFolderV1DocumentFoldersMovePatch
     * @summary Move Folder
     * @request PATCH:/v1/document-folders/move
     * @secure
     */
    moveFolderV1DocumentFoldersMovePatch: (
      data: MoveFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<MoveFolderResponse, HTTPValidationError>({
        path: `/v1/document-folders/move`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name DeleteFolderV1DocumentFoldersFolderIdDelete
     * @summary Delete Folder
     * @request DELETE:/v1/document-folders/{folder_id}
     * @secure
     */
    deleteFolderV1DocumentFoldersFolderIdDelete: (
      { folderId, ...query }: DeleteFolderV1DocumentFoldersFolderIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteFolderResponse, HTTPValidationError>({
        path: `/v1/document-folders/${folderId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name CreatePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkPost
     * @summary Create Public Folder Link
     * @request POST:/v1/document-folders/{folder_id}/public-link
     * @secure
     */
    createPublicFolderLinkV1DocumentFoldersFolderIdPublicLinkPost: (
      {
        folderId,
      }: CreatePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkPostParams,
      params: RequestParams = {},
    ) =>
      this.request<CreatePublicFolderLinkResponse, HTTPValidationError>({
        path: `/v1/document-folders/${folderId}/public-link`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name DeletePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkDelete
     * @summary Delete Public Folder Link
     * @request DELETE:/v1/document-folders/{folder_id}/public-link
     * @secure
     */
    deletePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkDelete: (
      {
        folderId,
      }: DeletePublicFolderLinkV1DocumentFoldersFolderIdPublicLinkDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePublicFolderLinkResponse, HTTPValidationError>({
        path: `/v1/document-folders/${folderId}/public-link`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags document folders
     * @name MoveDocumentV1DocumentFoldersDocumentsMovePatch
     * @summary Move Document
     * @request PATCH:/v1/document-folders/documents/move
     * @secure
     */
    moveDocumentV1DocumentFoldersDocumentsMovePatch: (
      data: MoveDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<MoveDocumentResponse, HTTPValidationError>({
        path: `/v1/document-folders/documents/move`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name GetListV1IncidentTypesGet
     * @summary Get List
     * @request GET:/v1/incident-types
     * @secure
     */
    getListV1IncidentTypesGet: (
      query: GetListV1IncidentTypesGetParams,
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<GetIncidentTypeListResponse, HTTPValidationError>({
        path: `/v1/incident-types`,
        method: "GET",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name CreateV1IncidentTypesPost
     * @summary Create
     * @request POST:/v1/incident-types
     * @secure
     */
    createV1IncidentTypesPost: (
      data: CreateIncidentTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateIncidentTypeResponse, HTTPValidationError>({
        path: `/v1/incident-types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name UpdateV1IncidentTypesPatch
     * @summary Update
     * @request PATCH:/v1/incident-types
     * @secure
     */
    updateV1IncidentTypesPatch: (
      data: UpdateIncidentTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateIncidentTypeResponse, void | HTTPValidationError>({
        path: `/v1/incident-types`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name RemoveV1IncidentTypesIdDelete
     * @summary Remove
     * @request DELETE:/v1/incident-types/{id}
     * @secure
     */
    removeV1IncidentTypesIdDelete: (
      { id }: RemoveV1IncidentTypesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteIncidentTypeResponse, HTTPValidationError>({
        path: `/v1/incident-types/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name UpdatePartiallyV1IncidentTypesPartiallyPatch
     * @summary Update Partially
     * @request PATCH:/v1/incident-types/partially
     * @secure
     */
    updatePartiallyV1IncidentTypesPartiallyPatch: (
      data: UpdateIncidentTypePartiallyRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateIncidentTypePartiallyResponse,
        void | HTTPValidationError
      >({
        path: `/v1/incident-types/partially`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident types
     * @name RestoreIncidentTypeV1IncidentTypesRestorePost
     * @summary Restore Incident Type
     * @request POST:/v1/incident-types/restore
     * @secure
     */
    restoreIncidentTypeV1IncidentTypesRestorePost: (
      data: RestoreIncidentTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreIncidentTypeResponse, void | HTTPValidationError>({
        path: `/v1/incident-types/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name GetListV1IncidentResultsGet
     * @summary Get List
     * @request GET:/v1/incident-results
     * @secure
     */
    getListV1IncidentResultsGet: (
      query: GetListV1IncidentResultsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIncidentResultListResponse, HTTPValidationError>({
        path: `/v1/incident-results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name CreateV1IncidentResultsPost
     * @summary Create
     * @request POST:/v1/incident-results
     * @secure
     */
    createV1IncidentResultsPost: (
      data: CreateIncidentResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateIncidentResultResponse, HTTPValidationError>({
        path: `/v1/incident-results`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name UpdateIncidentResultV1IncidentResultsPatch
     * @summary Update Incident Result
     * @request PATCH:/v1/incident-results
     * @secure
     */
    updateIncidentResultV1IncidentResultsPatch: (
      data: UpdateIncidentResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateIncidentResultResponse, void | HTTPValidationError>({
        path: `/v1/incident-results`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name ResolveIncidentResultV1IncidentResultsResolvePatch
     * @summary Resolve Incident Result
     * @request PATCH:/v1/incident-results/resolve
     * @secure
     */
    resolveIncidentResultV1IncidentResultsResolvePatch: (
      data: ResolveIncidentResultResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<ResolveIncidentResultResponse, void | HTTPValidationError>({
        path: `/v1/incident-results/resolve`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name UpdateIncidentResultPartiallyV1IncidentResultsPartiallyPatch
     * @summary Update Incident Result Partially
     * @request PATCH:/v1/incident-results/partially
     * @secure
     */
    updateIncidentResultPartiallyV1IncidentResultsPartiallyPatch: (
      data: UpdateIncidentResultPartiallyRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateIncidentResultPartiallyResponse,
        void | HTTPValidationError
      >({
        path: `/v1/incident-results/partially`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name DeleteIncidentResultV1IncidentResultsIdDelete
     * @summary Delete Incident Result
     * @request DELETE:/v1/incident-results/{id}
     * @secure
     */
    deleteIncidentResultV1IncidentResultsIdDelete: (
      { id }: DeleteIncidentResultV1IncidentResultsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteIncidentResultResponse, void | HTTPValidationError>({
        path: `/v1/incident-results/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags incident results
     * @name RestoreIncidentResultV1IncidentResultsRestorePost
     * @summary Restore Incident Result
     * @request POST:/v1/incident-results/restore
     * @secure
     */
    restoreIncidentResultV1IncidentResultsRestorePost: (
      data: RestoreIncidentResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreIncidentResultResponse, void | HTTPValidationError>({
        path: `/v1/incident-results/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name BackChannelLogoutV1WebhookBackChannelLogoutPost
     * @summary Back Channel Logout
     * @request POST:/v1/webhook/back-channel-logout
     */
    backChannelLogoutV1WebhookBackChannelLogoutPost: (
      data: BackChannelLogoutRequest,
      params: RequestParams = {},
    ) =>
      this.request<BackChannelLogoutResponse, HTTPValidationError>({
        path: `/v1/webhook/back-channel-logout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name KeycloakEventWebhookV1WebhookKeycloakEventPost
     * @summary Keycloak Event Webhook
     * @request POST:/v1/webhook/keycloak-event
     */
    keycloakEventWebhookV1WebhookKeycloakEventPost: (
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<WebhookEventsResponse, HTTPValidationError>({
        path: `/v1/webhook/keycloak-event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhook
     * @name RecallMeetingWebhookV1WebhookRecallMeetingWebhookPost
     * @summary Recall Meeting Webhook
     * @request POST:/v1/webhook/recall-meeting-webhook
     */
    recallMeetingWebhookV1WebhookRecallMeetingWebhookPost: (
      params: RequestParams = {},
    ) =>
      this.request<RecallMeetingWebhookResponse, any>({
        path: `/v1/webhook/recall-meeting-webhook`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name CustomChartCalculationsV1CustomChartsCalculationsGet
     * @summary Custom Chart Calculations
     * @request GET:/v1/custom-charts/calculations
     * @secure
     */
    customChartCalculationsV1CustomChartsCalculationsGet: (
      query: CustomChartCalculationsV1CustomChartsCalculationsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<CustomChartCalculationsResponse, HTTPValidationError>({
        path: `/v1/custom-charts/calculations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name GetCustomChartListV1CustomChartsGet
     * @summary Get Custom Chart List
     * @request GET:/v1/custom-charts
     * @secure
     */
    getCustomChartListV1CustomChartsGet: (
      query: GetCustomChartListV1CustomChartsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCustomChartListResponse, HTTPValidationError>({
        path: `/v1/custom-charts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name CreateCustomChartV1CustomChartsPost
     * @summary Create Custom Chart
     * @request POST:/v1/custom-charts
     * @secure
     */
    createCustomChartV1CustomChartsPost: (
      data: CreateCustomChartRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateCustomChartResponse, HTTPValidationError>({
        path: `/v1/custom-charts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name UpdateCustomChartV1CustomChartsPatch
     * @summary Update Custom Chart
     * @request PATCH:/v1/custom-charts
     * @secure
     */
    updateCustomChartV1CustomChartsPatch: (
      data: UpdateCustomChartRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCustomChartResponse, void | HTTPValidationError>({
        path: `/v1/custom-charts`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name GetCustomChartV1CustomChartsIdGet
     * @summary Get Custom Chart
     * @request GET:/v1/custom-charts/{id}
     * @secure
     */
    getCustomChartV1CustomChartsIdGet: (
      { id }: GetCustomChartV1CustomChartsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCustomChartResponse, void | HTTPValidationError>({
        path: `/v1/custom-charts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name RemoveCustomChartV1CustomChartsIdDelete
     * @summary Remove Custom Chart
     * @request DELETE:/v1/custom-charts/{id}
     * @secure
     */
    removeCustomChartV1CustomChartsIdDelete: (
      { id }: RemoveCustomChartV1CustomChartsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteCustomChartResponse, HTTPValidationError>({
        path: `/v1/custom-charts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags custom charts
     * @name RestoreCustomChartV1CustomChartsRestorePost
     * @summary Restore Custom Chart
     * @request POST:/v1/custom-charts/restore
     * @secure
     */
    restoreCustomChartV1CustomChartsRestorePost: (
      data: RestoreCustomChartRequest,
      params: RequestParams = {},
    ) =>
      this.request<RestoreCustomChartResponse, HTTPValidationError>({
        path: `/v1/custom-charts/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get AI context data by executing all queries in parallel with isolated request scopes.
     *
     * @tags ai context
     * @name GetAiContextV1AiContextGet
     * @summary Get Ai Context
     * @request GET:/v1/ai-context
     * @secure
     */
    getAiContextV1AiContextGet: (
      query: GetAiContextV1AiContextGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAIContextResponse, HTTPValidationError>({
        path: `/v1/ai-context`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai knowledge
     * @name GetAiKnowledgeItemListV1AiKnowledgeGet
     * @summary Get Ai Knowledge Item List
     * @request GET:/v1/ai-knowledge
     * @secure
     */
    getAiKnowledgeItemListV1AiKnowledgeGet: (params: RequestParams = {}) =>
      this.request<GetAIKnowledgeItemListResponse, any>({
        path: `/v1/ai-knowledge`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai knowledge
     * @name CreateAiKnowledgeItemV1AiKnowledgePost
     * @summary Create Ai Knowledge Item
     * @request POST:/v1/ai-knowledge
     * @secure
     */
    createAiKnowledgeItemV1AiKnowledgePost: (
      data: CreateAIKnowledgeItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAIKnowledgeItemResponse, HTTPValidationError>({
        path: `/v1/ai-knowledge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai knowledge
     * @name UpdateAiKnowledgeItemV1AiKnowledgePatch
     * @summary Update Ai Knowledge Item
     * @request PATCH:/v1/ai-knowledge
     * @secure
     */
    updateAiKnowledgeItemV1AiKnowledgePatch: (
      data: UpdateAIKnowledgeItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAIKnowledgeItemResponse, HTTPValidationError>({
        path: `/v1/ai-knowledge`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai knowledge
     * @name DeleteAiKnowledgeItemV1AiKnowledgeIdDelete
     * @summary Delete Ai Knowledge Item
     * @request DELETE:/v1/ai-knowledge/{id}
     * @secure
     */
    deleteAiKnowledgeItemV1AiKnowledgeIdDelete: (
      { id }: DeleteAiKnowledgeItemV1AiKnowledgeIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAIKnowledgeItemResponse, HTTPValidationError>({
        path: `/v1/ai-knowledge/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings
     * @name ListScheduledMeetingsV1MeetingsGet
     * @summary List Scheduled Meetings
     * @request GET:/v1/meetings
     * @secure
     */
    listScheduledMeetingsV1MeetingsGet: (
      query: ListScheduledMeetingsV1MeetingsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetScheduledMeetingsResponse, HTTPValidationError>({
        path: `/v1/meetings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Request to schedule a Microsoft Teams meeting.
     *
     * @tags meetings
     * @name ScheduleMeetingV1MeetingsPost
     * @summary Schedule Meeting
     * @request POST:/v1/meetings
     * @secure
     */
    scheduleMeetingV1MeetingsPost: (
      data: ScheduleMeetingRequest,
      params: RequestParams = {},
    ) =>
      this.request<ScheduleMeetingResponse, HTTPValidationError>({
        path: `/v1/meetings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings
     * @name GetScheduledMeetingV1MeetingsMeetingIdGet
     * @summary Get Scheduled Meeting
     * @request GET:/v1/meetings/{meeting_id}
     * @secure
     */
    getScheduledMeetingV1MeetingsMeetingIdGet: (
      { meetingId }: GetScheduledMeetingV1MeetingsMeetingIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetScheduledMeetingResponse, HTTPValidationError>({
        path: `/v1/meetings/${meetingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a scheduled meeting.
     *
     * @tags meetings
     * @name UpdateMeetingV1MeetingsMeetingIdPut
     * @summary Update Meeting
     * @request PUT:/v1/meetings/{meeting_id}
     * @secure
     */
    updateMeetingV1MeetingsMeetingIdPut: (
      { meetingId }: UpdateMeetingV1MeetingsMeetingIdPutParams,
      data: ScheduleMeetingRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateScheduledMeetingResponse, HTTPValidationError>({
        path: `/v1/meetings/${meetingId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings
     * @name DeleteScheduledMeetingV1MeetingsMeetingIdDelete
     * @summary Delete Scheduled Meeting
     * @request DELETE:/v1/meetings/{meeting_id}
     * @secure
     */
    deleteScheduledMeetingV1MeetingsMeetingIdDelete: (
      { meetingId }: DeleteScheduledMeetingV1MeetingsMeetingIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/meetings/${meetingId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings
     * @name GetMeetingDocumentsV1MeetingsMeetingIdDocumentsGet
     * @summary Get Meeting Documents
     * @request GET:/v1/meetings/{meeting_id}/documents
     * @secure
     */
    getMeetingDocumentsV1MeetingsMeetingIdDocumentsGet: (
      {
        meetingId,
        ...query
      }: GetMeetingDocumentsV1MeetingsMeetingIdDocumentsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetMeetingDocumentsResponse, HTTPValidationError>({
        path: `/v1/meetings/${meetingId}/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags meetings
     * @name ListMeetingSummaryTemplatesV1MeetingsTemplatesGet
     * @summary List Meeting Summary Templates
     * @request GET:/v1/meetings/templates
     * @secure
     */
    listMeetingSummaryTemplatesV1MeetingsTemplatesGet: (
      params: RequestParams = {},
    ) =>
      this.request<GetMeetingSummaryTemplatesResponse, any>({
        path: `/v1/meetings/templates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clients
     * @name GetClientsListV1ClientsGet
     * @summary Get Clients List
     * @request GET:/v1/clients
     * @secure
     */
    getClientsListV1ClientsGet: (
      query: GetClientsListV1ClientsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetClientsListResponse, HTTPValidationError>({
        path: `/v1/clients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clients
     * @name CreateClientV1ClientsPost
     * @summary Create Client
     * @request POST:/v1/clients
     * @secure
     */
    createClientV1ClientsPost: (
      data: CreateClientRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateClientResponse, HTTPValidationError>({
        path: `/v1/clients`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clients
     * @name UpdateClientV1ClientsIdPut
     * @summary Update Client
     * @request PUT:/v1/clients/{id}
     * @secure
     */
    updateClientV1ClientsIdPut: (
      { id }: UpdateClientV1ClientsIdPutParams,
      data: UpdateClientRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateClientResponse, HTTPValidationError>({
        path: `/v1/clients/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags clients
     * @name DeleteClientV1ClientsIdDelete
     * @summary Delete Client
     * @request DELETE:/v1/clients/{id}
     * @secure
     */
    deleteClientV1ClientsIdDelete: (
      { id }: DeleteClientV1ClientsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteClientResponse, HTTPValidationError>({
        path: `/v1/clients/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractCreateLookupsV1ContractsLookupsCreateContractGet
     * @summary Get Contract Create Lookups
     * @request GET:/v1/contracts/lookups/create-contract
     * @secure
     */
    getContractCreateLookupsV1ContractsLookupsCreateContractGet: (
      query: GetContractCreateLookupsV1ContractsLookupsCreateContractGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractCreateLookupsResponse, HTTPValidationError>({
        path: `/v1/contracts/lookups/create-contract`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetJurisdictionsV1ContractsJurisdictionsGet
     * @summary Get Jurisdictions
     * @request GET:/v1/contracts/jurisdictions
     * @secure
     */
    getJurisdictionsV1ContractsJurisdictionsGet: (
      query: GetJurisdictionsV1ContractsJurisdictionsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetJurisdictionsListResponse, HTTPValidationError>({
        path: `/v1/contracts/jurisdictions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreateJurisdictionV1ContractsJurisdictionsPost
     * @summary Create Jurisdiction
     * @request POST:/v1/contracts/jurisdictions
     * @secure
     */
    createJurisdictionV1ContractsJurisdictionsPost: (
      data: CreateJurisdictionRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateJurisdictionResponse, HTTPValidationError>({
        path: `/v1/contracts/jurisdictions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetJurisdictionV1ContractsJurisdictionsIdGet
     * @summary Get Jurisdiction
     * @request GET:/v1/contracts/jurisdictions/{id}
     * @secure
     */
    getJurisdictionV1ContractsJurisdictionsIdGet: (
      { id }: GetJurisdictionV1ContractsJurisdictionsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetJurisdictionResponse, HTTPValidationError>({
        path: `/v1/contracts/jurisdictions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeleteJurisdictionV1ContractsJurisdictionsIdDelete
     * @summary Delete Jurisdiction
     * @request DELETE:/v1/contracts/jurisdictions/{id}
     * @secure
     */
    deleteJurisdictionV1ContractsJurisdictionsIdDelete: (
      { id }: DeleteJurisdictionV1ContractsJurisdictionsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteJurisdictionResponse, HTTPValidationError>({
        path: `/v1/contracts/jurisdictions/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdateJurisdictionV1ContractsJurisdictionsIdPatch
     * @summary Update Jurisdiction
     * @request PATCH:/v1/contracts/jurisdictions/{id}
     * @secure
     */
    updateJurisdictionV1ContractsJurisdictionsIdPatch: (
      { id }: UpdateJurisdictionV1ContractsJurisdictionsIdPatchParams,
      data: UpdateJurisdictionRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateJurisdictionResponse, HTTPValidationError>({
        path: `/v1/contracts/jurisdictions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartiesV1ContractsPartiesGet
     * @summary Get Parties
     * @request GET:/v1/contracts/parties
     * @secure
     */
    getPartiesV1ContractsPartiesGet: (
      query: GetPartiesV1ContractsPartiesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartiesListResponse, HTTPValidationError>({
        path: `/v1/contracts/parties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreatePartyV1ContractsPartiesPost
     * @summary Create Party
     * @request POST:/v1/contracts/parties
     * @secure
     */
    createPartyV1ContractsPartiesPost: (
      data: CreatePartyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePartyResponse, HTTPValidationError>({
        path: `/v1/contracts/parties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartyV1ContractsPartiesIdGet
     * @summary Get Party
     * @request GET:/v1/contracts/parties/{id}
     * @secure
     */
    getPartyV1ContractsPartiesIdGet: (
      { id }: GetPartyV1ContractsPartiesIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartyResponse, HTTPValidationError>({
        path: `/v1/contracts/parties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeletePartyV1ContractsPartiesIdDelete
     * @summary Delete Party
     * @request DELETE:/v1/contracts/parties/{id}
     * @secure
     */
    deletePartyV1ContractsPartiesIdDelete: (
      { id }: DeletePartyV1ContractsPartiesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePartyResponse, HTTPValidationError>({
        path: `/v1/contracts/parties/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdatePartyV1ContractsPartiesIdPatch
     * @summary Update Party
     * @request PATCH:/v1/contracts/parties/{id}
     * @secure
     */
    updatePartyV1ContractsPartiesIdPatch: (
      { id }: UpdatePartyV1ContractsPartiesIdPatchParams,
      data: UpdatePartyRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePartyResponse, HTTPValidationError>({
        path: `/v1/contracts/parties/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartyContactsV1ContractsPartyContactsGet
     * @summary Get Party Contacts
     * @request GET:/v1/contracts/party-contacts
     * @secure
     */
    getPartyContactsV1ContractsPartyContactsGet: (
      query: GetPartyContactsV1ContractsPartyContactsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartyContactsListResponse, HTTPValidationError>({
        path: `/v1/contracts/party-contacts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreatePartyContactV1ContractsPartyContactsPost
     * @summary Create Party Contact
     * @request POST:/v1/contracts/party-contacts
     * @secure
     */
    createPartyContactV1ContractsPartyContactsPost: (
      data: CreatePartyContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePartyContactResponse, HTTPValidationError>({
        path: `/v1/contracts/party-contacts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartyContactV1ContractsPartyContactsIdGet
     * @summary Get Party Contact
     * @request GET:/v1/contracts/party-contacts/{id}
     * @secure
     */
    getPartyContactV1ContractsPartyContactsIdGet: (
      { id }: GetPartyContactV1ContractsPartyContactsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartyContactResponse, HTTPValidationError>({
        path: `/v1/contracts/party-contacts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeletePartyContactV1ContractsPartyContactsIdDelete
     * @summary Delete Party Contact
     * @request DELETE:/v1/contracts/party-contacts/{id}
     * @secure
     */
    deletePartyContactV1ContractsPartyContactsIdDelete: (
      { id }: DeletePartyContactV1ContractsPartyContactsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePartyContactResponse, HTTPValidationError>({
        path: `/v1/contracts/party-contacts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdatePartyContactV1ContractsPartyContactsIdPatch
     * @summary Update Party Contact
     * @request PATCH:/v1/contracts/party-contacts/{id}
     * @secure
     */
    updatePartyContactV1ContractsPartyContactsIdPatch: (
      { id }: UpdatePartyContactV1ContractsPartyContactsIdPatchParams,
      data: UpdatePartyContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePartyContactResponse, HTTPValidationError>({
        path: `/v1/contracts/party-contacts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartyComplianceV1ContractsPartyComplianceGet
     * @summary Get Party Compliance
     * @request GET:/v1/contracts/party-compliance
     * @secure
     */
    getPartyComplianceV1ContractsPartyComplianceGet: (
      query: GetPartyComplianceV1ContractsPartyComplianceGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartyComplianceListResponse, HTTPValidationError>({
        path: `/v1/contracts/party-compliance`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreatePartyComplianceV1ContractsPartyCompliancePost
     * @summary Create Party Compliance
     * @request POST:/v1/contracts/party-compliance
     * @secure
     */
    createPartyComplianceV1ContractsPartyCompliancePost: (
      data: CreatePartyComplianceRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePartyComplianceResponse, HTTPValidationError>({
        path: `/v1/contracts/party-compliance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPartyComplianceItemV1ContractsPartyComplianceIdGet
     * @summary Get Party Compliance Item
     * @request GET:/v1/contracts/party-compliance/{id}
     * @secure
     */
    getPartyComplianceItemV1ContractsPartyComplianceIdGet: (
      { id }: GetPartyComplianceItemV1ContractsPartyComplianceIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPartyComplianceResponse, HTTPValidationError>({
        path: `/v1/contracts/party-compliance/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeletePartyComplianceV1ContractsPartyComplianceIdDelete
     * @summary Delete Party Compliance
     * @request DELETE:/v1/contracts/party-compliance/{id}
     * @secure
     */
    deletePartyComplianceV1ContractsPartyComplianceIdDelete: (
      { id }: DeletePartyComplianceV1ContractsPartyComplianceIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePartyComplianceResponse, HTTPValidationError>({
        path: `/v1/contracts/party-compliance/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdatePartyComplianceV1ContractsPartyComplianceIdPatch
     * @summary Update Party Compliance
     * @request PATCH:/v1/contracts/party-compliance/{id}
     * @secure
     */
    updatePartyComplianceV1ContractsPartyComplianceIdPatch: (
      { id }: UpdatePartyComplianceV1ContractsPartyComplianceIdPatchParams,
      data: UpdatePartyComplianceRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePartyComplianceResponse, HTTPValidationError>({
        path: `/v1/contracts/party-compliance/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractPartiesV1ContractsContractPartiesGet
     * @summary Get Contract Parties
     * @request GET:/v1/contracts/contract-parties
     * @secure
     */
    getContractPartiesV1ContractsContractPartiesGet: (
      query: GetContractPartiesV1ContractsContractPartiesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractPartiesListResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-parties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreateContractPartyV1ContractsContractPartiesPost
     * @summary Create Contract Party
     * @request POST:/v1/contracts/contract-parties
     * @secure
     */
    createContractPartyV1ContractsContractPartiesPost: (
      data: CreateContractPartyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateContractPartyResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-parties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractPartyV1ContractsContractPartiesIdGet
     * @summary Get Contract Party
     * @request GET:/v1/contracts/contract-parties/{id}
     * @secure
     */
    getContractPartyV1ContractsContractPartiesIdGet: (
      { id }: GetContractPartyV1ContractsContractPartiesIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractPartyResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-parties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeleteContractPartyV1ContractsContractPartiesIdDelete
     * @summary Delete Contract Party
     * @request DELETE:/v1/contracts/contract-parties/{id}
     * @secure
     */
    deleteContractPartyV1ContractsContractPartiesIdDelete: (
      { id }: DeleteContractPartyV1ContractsContractPartiesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteContractPartyResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-parties/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdateContractPartyV1ContractsContractPartiesIdPatch
     * @summary Update Contract Party
     * @request PATCH:/v1/contracts/contract-parties/{id}
     * @secure
     */
    updateContractPartyV1ContractsContractPartiesIdPatch: (
      { id }: UpdateContractPartyV1ContractsContractPartiesIdPatchParams,
      data: UpdateContractPartyRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateContractPartyResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-parties/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractContributorsV1ContractsContractContributorsGet
     * @summary Get Contract Contributors
     * @request GET:/v1/contracts/contract-contributors
     * @secure
     */
    getContractContributorsV1ContractsContractContributorsGet: (
      query: GetContractContributorsV1ContractsContractContributorsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractContributorsListResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-contributors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreateContractContributorV1ContractsContractContributorsPost
     * @summary Create Contract Contributor
     * @request POST:/v1/contracts/contract-contributors
     * @secure
     */
    createContractContributorV1ContractsContractContributorsPost: (
      data: CreateContractContributorRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateContractContributorResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-contributors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractContributorV1ContractsContractContributorsIdGet
     * @summary Get Contract Contributor
     * @request GET:/v1/contracts/contract-contributors/{id}
     * @secure
     */
    getContractContributorV1ContractsContractContributorsIdGet: (
      { id }: GetContractContributorV1ContractsContractContributorsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractContributorResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-contributors/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeleteContractContributorV1ContractsContractContributorsIdDelete
     * @summary Delete Contract Contributor
     * @request DELETE:/v1/contracts/contract-contributors/{id}
     * @secure
     */
    deleteContractContributorV1ContractsContractContributorsIdDelete: (
      {
        id,
      }: DeleteContractContributorV1ContractsContractContributorsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteContractContributorResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-contributors/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdateContractContributorV1ContractsContractContributorsIdPatch
     * @summary Update Contract Contributor
     * @request PATCH:/v1/contracts/contract-contributors/{id}
     * @secure
     */
    updateContractContributorV1ContractsContractContributorsIdPatch: (
      {
        id,
      }: UpdateContractContributorV1ContractsContractContributorsIdPatchParams,
      data: UpdateContractContributorRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateContractContributorResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-contributors/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPolicyCoveragesV1ContractsPolicyCoveragesGet
     * @summary Get Policy Coverages
     * @request GET:/v1/contracts/policy-coverages
     * @secure
     */
    getPolicyCoveragesV1ContractsPolicyCoveragesGet: (
      query: GetPolicyCoveragesV1ContractsPolicyCoveragesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPolicyCoveragesListResponse, HTTPValidationError>({
        path: `/v1/contracts/policy-coverages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreatePolicyCoverageV1ContractsPolicyCoveragesPost
     * @summary Create Policy Coverage
     * @request POST:/v1/contracts/policy-coverages
     * @secure
     */
    createPolicyCoverageV1ContractsPolicyCoveragesPost: (
      data: CreatePolicyCoverageRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatePolicyCoverageResponse, HTTPValidationError>({
        path: `/v1/contracts/policy-coverages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetPolicyCoverageV1ContractsPolicyCoveragesIdGet
     * @summary Get Policy Coverage
     * @request GET:/v1/contracts/policy-coverages/{id}
     * @secure
     */
    getPolicyCoverageV1ContractsPolicyCoveragesIdGet: (
      { id }: GetPolicyCoverageV1ContractsPolicyCoveragesIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPolicyCoverageResponse, HTTPValidationError>({
        path: `/v1/contracts/policy-coverages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeletePolicyCoverageV1ContractsPolicyCoveragesIdDelete
     * @summary Delete Policy Coverage
     * @request DELETE:/v1/contracts/policy-coverages/{id}
     * @secure
     */
    deletePolicyCoverageV1ContractsPolicyCoveragesIdDelete: (
      { id }: DeletePolicyCoverageV1ContractsPolicyCoveragesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePolicyCoverageResponse, HTTPValidationError>({
        path: `/v1/contracts/policy-coverages/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdatePolicyCoverageV1ContractsPolicyCoveragesIdPatch
     * @summary Update Policy Coverage
     * @request PATCH:/v1/contracts/policy-coverages/{id}
     * @secure
     */
    updatePolicyCoverageV1ContractsPolicyCoveragesIdPatch: (
      { id }: UpdatePolicyCoverageV1ContractsPolicyCoveragesIdPatchParams,
      data: UpdatePolicyCoverageRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePolicyCoverageResponse, HTTPValidationError>({
        path: `/v1/contracts/policy-coverages/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractFilesV1ContractsContractFilesGet
     * @summary Get Contract Files
     * @request GET:/v1/contracts/contract-files
     * @secure
     */
    getContractFilesV1ContractsContractFilesGet: (
      query: GetContractFilesV1ContractsContractFilesGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractFilesListResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-files`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreateContractFileV1ContractsContractFilesPost
     * @summary Create Contract File
     * @request POST:/v1/contracts/contract-files
     * @secure
     */
    createContractFileV1ContractsContractFilesPost: (
      data: CreateContractFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateContractFileResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-files`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractFileV1ContractsContractFilesIdGet
     * @summary Get Contract File
     * @request GET:/v1/contracts/contract-files/{id}
     * @secure
     */
    getContractFileV1ContractsContractFilesIdGet: (
      { id }: GetContractFileV1ContractsContractFilesIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractFileResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeleteContractFileV1ContractsContractFilesIdDelete
     * @summary Delete Contract File
     * @request DELETE:/v1/contracts/contract-files/{id}
     * @secure
     */
    deleteContractFileV1ContractsContractFilesIdDelete: (
      { id }: DeleteContractFileV1ContractsContractFilesIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteContractFileResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-files/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdateContractFileV1ContractsContractFilesIdPatch
     * @summary Update Contract File
     * @request PATCH:/v1/contracts/contract-files/{id}
     * @secure
     */
    updateContractFileV1ContractsContractFilesIdPatch: (
      { id }: UpdateContractFileV1ContractsContractFilesIdPatchParams,
      data: UpdateContractFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateContractFileResponse, HTTPValidationError>({
        path: `/v1/contracts/contract-files/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractsV1ContractsGet
     * @summary Get Contracts
     * @request GET:/v1/contracts
     * @secure
     */
    getContractsV1ContractsGet: (
      query: GetContractsV1ContractsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractsListResponse, HTTPValidationError>({
        path: `/v1/contracts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name CreateContractV1ContractsPost
     * @summary Create Contract
     * @request POST:/v1/contracts
     * @secure
     */
    createContractV1ContractsPost: (
      data: CreateContractRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateContractResponse, HTTPValidationError>({
        path: `/v1/contracts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name GetContractV1ContractsIdGet
     * @summary Get Contract
     * @request GET:/v1/contracts/{id}
     * @secure
     */
    getContractV1ContractsIdGet: (
      { id }: GetContractV1ContractsIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetContractResponse, HTTPValidationError>({
        path: `/v1/contracts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name DeleteContractV1ContractsIdDelete
     * @summary Delete Contract
     * @request DELETE:/v1/contracts/{id}
     * @secure
     */
    deleteContractV1ContractsIdDelete: (
      { id }: DeleteContractV1ContractsIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteContractResponse, HTTPValidationError>({
        path: `/v1/contracts/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contracts
     * @name UpdateContractV1ContractsIdPatch
     * @summary Update Contract
     * @request PATCH:/v1/contracts/{id}
     * @secure
     */
    updateContractV1ContractsIdPatch: (
      { id }: UpdateContractV1ContractsIdPatchParams,
      data: UpdateContractRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateContractResponse, HTTPValidationError>({
        path: `/v1/contracts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name GetVaultsV1SecretManagerVaultsGet
     * @summary Get Vaults
     * @request GET:/v1/secret-manager/vaults
     * @secure
     */
    getVaultsV1SecretManagerVaultsGet: (
      query: GetVaultsV1SecretManagerVaultsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVaultsResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name CreateVaultV1SecretManagerVaultsPost
     * @summary Create Vault
     * @request POST:/v1/secret-manager/vaults
     * @secure
     */
    createVaultV1SecretManagerVaultsPost: (
      data: CreateVaultRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateVaultResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name UpdateVaultV1SecretManagerVaultsPatch
     * @summary Update Vault
     * @request PATCH:/v1/secret-manager/vaults
     * @secure
     */
    updateVaultV1SecretManagerVaultsPatch: (
      data: UpdateVaultRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateVaultResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name GetVaultV1SecretManagerVaultsVaultIdGet
     * @summary Get Vault
     * @request GET:/v1/secret-manager/vaults/{vault_id}
     * @secure
     */
    getVaultV1SecretManagerVaultsVaultIdGet: (
      { vaultId }: GetVaultV1SecretManagerVaultsVaultIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVaultResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults/${vaultId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name DeleteVaultV1SecretManagerVaultsVaultIdDelete
     * @summary Delete Vault
     * @request DELETE:/v1/secret-manager/vaults/{vault_id}
     * @secure
     */
    deleteVaultV1SecretManagerVaultsVaultIdDelete: (
      { vaultId }: DeleteVaultV1SecretManagerVaultsVaultIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteVaultResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults/${vaultId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name ShareVaultV1SecretManagerVaultsSharePatch
     * @summary Share Vault
     * @request PATCH:/v1/secret-manager/vaults/share
     * @secure
     */
    shareVaultV1SecretManagerVaultsSharePatch: (
      data: ShareVaultRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareVaultResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults/share`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name GetVaultSecretsV1SecretManagerVaultsVaultIdSecretsGet
     * @summary Get Vault Secrets
     * @request GET:/v1/secret-manager/vaults/{vault_id}/secrets
     * @secure
     */
    getVaultSecretsV1SecretManagerVaultsVaultIdSecretsGet: (
      {
        vaultId,
        ...query
      }: GetVaultSecretsV1SecretManagerVaultsVaultIdSecretsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVaultSecretsResponse, HTTPValidationError>({
        path: `/v1/secret-manager/vaults/${vaultId}/secrets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name CreateSecretV1SecretManagerSecretsPost
     * @summary Create Secret
     * @request POST:/v1/secret-manager/secrets
     * @secure
     */
    createSecretV1SecretManagerSecretsPost: (
      data: CreateSecretRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateSecretResponse, HTTPValidationError>({
        path: `/v1/secret-manager/secrets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name UpdateSecretV1SecretManagerSecretsPatch
     * @summary Update Secret
     * @request PATCH:/v1/secret-manager/secrets
     * @secure
     */
    updateSecretV1SecretManagerSecretsPatch: (
      data: UpdateSecretRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSecretResponse, HTTPValidationError>({
        path: `/v1/secret-manager/secrets`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags secret manager
     * @name DeleteSecretV1SecretManagerSecretsSecretIdDelete
     * @summary Delete Secret
     * @request DELETE:/v1/secret-manager/secrets/{secret_id}
     * @secure
     */
    deleteSecretV1SecretManagerSecretsSecretIdDelete: (
      {
        secretId,
        ...query
      }: DeleteSecretV1SecretManagerSecretsSecretIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSecretResponse, HTTPValidationError>({
        path: `/v1/secret-manager/secrets/${secretId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
